<template>
  <div>

    <el-container style="height: 2500px">
      <el-header>
        <el-card style="height:300px;width: 41%;margin:0 auto;">
          <el-descriptions class="margin-top" title="登录信息" :column="1" border>

            <template slot="extra">

              <el-button type="primary" @click="countdialogVisible = true" size="small">批量搭建</el-button>
              <!-- 弹窗 -->
              <el-dialog title="搭建配置" :visible.sync="countdialogVisible" width="500px" class="custom-dialog">
                <el-form label-position="left" label-width="180px" :model="countformData">
                  <!-- 普通素材输入 -->
                  <el-form-item label="单账户普通素材搭建数:">
                    <el-input-number v-model="countformData.normalCount" :min="0" controls-position="right"
                      placeholder="请输入数量" class="full-width-input"></el-input-number>
                  </el-form-item>

                  <!-- 撞审素材输入 -->
                  <el-form-item label="撞审素材搭建数:">
                    <el-input-number v-model="countformData.reviewCount" :min="0" controls-position="right"
                      placeholder="请输入数量" class="full-width-input"></el-input-number>
                  </el-form-item>
                </el-form>

                <div slot="footer" class="dialog-footer">
                  <el-button @click="countdialogVisible = false">取 消</el-button>
                  <el-button type="primary" @click="GetPlan" class="confirm-btn">
                    确 定
                  </el-button>
                </div>
              </el-dialog>
              <!--              <el-button type="primary" v-on:click="GetRo"  size="small">刷新</el-button>-->
              <el-button type="primary" v-on:click="findIds" size="small">查询</el-button>
              <el-button type="primary" v-on:click="clearfile" size="small">重置普通素材</el-button>
              <!--              <el-button type="primary" v-on:click="zsclearfile"  size="small">重置撞审素材</el-button>-->
              <!--              <span class="text-lg font-bold">今日总搭建数量：</span>-->
              <!--              <span class="text-xl text-primary">{{ advRecordTodayTotal }}</span>-->
              <!--              <el-button type="primary" v-on:click="sckhb"  size="small">ces</el-button>-->
              <!--              <el-button type="danger" @click="stopAll = true"  size="small">停止操作</el-button>-->

              <el-button type="primary" size="small" @click="openAdvRecordDetailDialog">
                搭建详情
              </el-button>
            </template>
            <el-descriptions-item>
              <template slot="label">
                <i class="el-icon-office-building"></i>
                账户名
              </template>
              <template>

                <el-input type="textarea" style="width: 440px;" v-model="accounts" placeholder="请输入账户名（每行一个）"
                  @input="handleInput"></el-input>
                <!--                  <el-button type="primary" onclick="findIds"  size="small">查询</el-button>-->

              </template>
            </el-descriptions-item>

            <!--            <el-descriptions-item>-->
            <!--              <template slot="label">-->
            <!--                <i class="el-icon-user"></i>-->
            <!--                姓名-->
            <!--              </template>-->
            <!--              <div class="block">-->
            <!--                &lt;!&ndash;              <el-cascader&ndash;&gt;-->
            <!--                &lt;!&ndash;                v-model="names"&ndash;&gt;-->
            <!--                &lt;!&ndash;                :options="name"&ndash;&gt;-->
            <!--                &lt;!&ndash;                filterable></el-cascader>&ndash;&gt;-->
            <!--                <el-select v-model="username"  filterable placeholder="请选择">-->
            <!--                  <el-option-->
            <!--                    v-for="(items,i) in listname"-->
            <!--                    :key="i"-->
            <!--                    :value="items.username">-->
            <!--                  </el-option>-->
            <!--                </el-select>-->
            <!--              </div>-->
            <!--            </el-descriptions-item>-->
            <!--            <el-descriptions-item>-->
            <!--              <template slot="label">-->
            <!--                <i class="el-icon-mobile-phone"></i>-->
            <!--                登录二代-->
            <!--              </template>-->
            <!--              微驰-->
            <!--            </el-descriptions-item>-->
            <!--            <el-descriptions-item>-->
            <!--              <template slot="label">-->
            <!--                <i class="el-icon-location-outline"></i>-->
            <!--                账户列表-->
            <!--              </template>-->

            <!--              <el-select v-model="towName" filterable placeholder="请选择">-->
            <!--                <el-option-->
            <!--                  v-for="(items,i) in two"-->
            <!--                  :key="i"-->
            <!--                  :value="items.twoname">-->
            <!--                </el-option>-->
            <!--              </el-select>-->

            <!--            </el-descriptions-item>-->



            <el-descriptions-item>
              <template slot="label">
                <i class="el-icon-office-building"></i>
                广告主账户列表
              </template>
              <!--            <el-select v-model="idsname" placeholder="请选择">-->
              <!--              <el-option-->
              <!--                v-for="(items,i) in idsList"-->
              <!--                :key="i"-->
              <!--                :value="items.idsname">-->
              <!--              </el-option>-->
              <!--            </el-select>-->
              <el-tag :key="i" v-for="(item, i) in idsList">{{ item.idsname }}</el-tag>
              <el-cascader v-model="erjihangye" :options="options5" filterable></el-cascader>
            </el-descriptions-item>
          </el-descriptions>
        </el-card>
      </el-header>
      <el-container>
        <el-aside width="1000px">
          <div style="height:500px;position: absolute;left:200px;top: 320px">
            <el-steps direction="vertical" :active="1">
              <el-step process-status="success" title="创建计划"></el-step>
              <el-step title="创建广告组"></el-step>
              <el-step process-status="success" title="创建广告" description="需要上传图片素材"></el-step>
            </el-steps>
          </div>




        </el-aside>
        <el-container>
          <el-main style="height: 1000px;width:1000px">
            <!--          搭建计划代码-->
            <el-card class="box-card1" style="padding: 20px;height: 220%;">
              <div slot="header" class="clearfix">
                <div style="margin-bottom: 10px">



                  <!-- 查询按钮 -->
                  <el-button type="danger" @click="clearShangPing">清空商品数据</el-button>
                  <el-select v-model="selectedCategoryName" placeholder="请选择分类" @change="handleCategoryChange"
                    style="width: 200px; margin-right: 10px;">
                    <el-option v-for="category in categories" :key="category.categoryId" :label="category.categoryName"
                      :value="category.categoryName"></el-option>
                  </el-select>
                  <!-- 查询按钮 -->
                  <el-button type="primary" @click="handleQuery">添加商品库</el-button>
                  <!-- 判断list是否为空，若不为空则显示选择框 -->
                  <el-select v-if="categoryList.length > 0" v-model="categoryName" @change="CategorySelectHandle"
                    placeholder="请选择" style="width: 200px; margin-right: 10px;">

                    <el-option v-for="item in categoryList" :key="item.id" :label="item.name"
                      :value="item.id"></el-option>
                  </el-select>
                </div>



                <!-- 第一个卡片内容 -->
                <el-form label-position="right" :model="formLabelAlign">
                  <el-form-item label="素材库选择:" style="margin-bottom: 8px;">
                    <el-select v-model="sucainame" placeholder="请选择分类" @change="handlesucaiku"
                      style="width: 200px; margin-right: 10px;">
                      <el-option v-for="sucaiku in sucaikus" :key="sucaiku.utoken" :label="sucaiku.uname"
                        :value="sucaiku.uname"></el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item label="计划名称:" style="margin-bottom: 8px;">
                    <el-input style="width: 200px" v-model="formLabelAlign.name"></el-input>
                  </el-form-item>




                  <el-form-item label="计划预算(不填代表不限):" style="margin-bottom: 8px;">
                    <el-input style="width: 200px" v-model="formLabelAlign.dailyBudget"></el-input>
                  </el-form-item>


                  <el-form-item label="推广目标" style="margin-bottom: 8px;">
                    <el-select v-model="beSelectAdType" placeholder="请选择">
                      <el-option v-for="item1 in adTypeList" :key="item1.value" :label="item1.label" :value="item1.value">
                      </el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item label="投放渠道:" style="margin-bottom: 8px;">
                    <el-select v-model="formLabelAlign.mediaType" placeholder="请选择">
                      <el-option v-for="item1 in option1" :key="item1.value" :label="item1.label" :value="item1.value">
                      </el-option>
                    </el-select>
                  </el-form-item>

                  <el-form-item label="计划开关:" style="margin-bottom: 8px;">
                    <el-switch v-model="flag" active-color="#13ce66" inactive-color="#ff4949">
                    </el-switch>
                  </el-form-item>
                  <el-form-item label="是否指定最新计划搭建:" style="margin-bottom: 8px;">
                    <el-switch v-model="newplanflag" active-color="#13ce66" inactive-color="#ff4949">
                    </el-switch>
                  </el-form-item>


                  <el-form-item label="是否微信一键关注（普通网址）:" style="margin-bottom: 8px;">
                    <el-switch v-model="isguanz" active-color="#13ce66" inactive-color="#ff4949">
                    </el-switch>
                  </el-form-item>
                </el-form>

                <!-- 第二个卡片内容 -->
                <el-form label-position="right" :model="formLabelAlign1">
                  <el-form-item label="转化目标:">
                    <el-select v-model="formLabelAlign1.cvType" placeholder="请选择">
                      <el-option v-for="item1 in options3" :key="item1.value" :label="item1.label" :value="item1.value">
                      </el-option>
                    </el-select>
                  </el-form-item>

                  <el-form-item label="二阶出价:" style="margin-top: 20px">
                    <el-input style="width: 100px;" v-model="formLabelAlign1.ocpxPrice"></el-input>元

                    <el-tag> 是否使用最新广告组出价</el-tag>
                    <el-switch v-model="isoldgroupprice" active-color="#13ce66" inactive-color="#ff4949">
                    </el-switch>
                  </el-form-item>

                  <el-form-item label="人群包id(小写逗号分开):" style="margin-top: 20px">
                    <el-input v-model="customList2"></el-input>
                  </el-form-item>
                  <el-form-item label="排除人群包id(小写逗号分开):" style="margin-top: 20px">
                    <el-input v-model="customListpc"></el-input>
                  </el-form-item>
                  <el-form-item label="投放时间段:">
                    <!--                    <el-select v-model="time_list" placeholder="请选择">-->
                    <!--                      <el-option-->
                    <!--                        v-for="item1 in timeList"-->
                    <!--                        :key="item1.value"-->
                    <!--                        :label="item1.label"-->
                    <!--                        :value="item1.value">-->
                    <!--                      </el-option>-->
                    <!--                    </el-select>-->


                    <div class="time-range-container">
                      <div v-for="(range, index) in timeRanges" :key="index" class="time-range-item">
                        <el-time-select v-model="range.start" :picker-options="startOptions(index)" placeholder="起始时间"
                          :max-time="range.end" @change="handleStartChange(index)" />
                        <span class="separator">-</span>
                        <el-time-select v-model="range.end" :picker-options="endOptions(index)" placeholder="结束时间"
                          :min-time="range.start" @change="handleEndChange(index)" />
                        <el-button v-if="index === timeRanges.length - 1" type="text" icon="el-icon-plus"
                          @click="addRange" :disabled="isLastEndMax" />
                        <el-button v-if="timeRanges.length > 1" type="text" icon="el-icon-minus"
                          @click="removeRange(index)" />
                      </div>
                      <!--                      <div class="result">结果：{{ this.time_list }}</div>-->
                    </div>
                  </el-form-item>


                  <el-form-item label="地域定向:">
                    <!-- 选择框 -->
                    <el-select v-model="beSelectDiYu" placeholder="请选择" @change="diYuHandleSelectionChange">
                      <el-option v-for="(item, index) in mapArray" :key="index" :label="item.name" :value="item.name">
                      </el-option>
                    </el-select>
                  </el-form-item>


                  <el-form-item label="性别:">
                    <el-radio-group v-model="sex">
                      <el-radio-button label="男"></el-radio-button>
                      <el-radio-button label="女"></el-radio-button>
                      <el-radio-button label="不限"></el-radio-button>
                    </el-radio-group>
                  </el-form-item>

                  <el-form-item label="年龄(不选即不限):">
                    <div>
                      <el-checkbox-group v-model="age">
                        <el-checkbox-button v-for="(item, i) in ages" :label="i" :key="i">
                          {{ item.value }}
                        </el-checkbox-button>
                      </el-checkbox-group>
                    </div>
                  </el-form-item>

                  <el-form-item label="机型设置">
                    <div id="app">
                      <el-checkbox-group v-model="selectedVersions">
                        <el-checkbox v-for="(version, index) in androidVersions" :key="version.value"
                          :label="version.value">
                          {{ version.label }}
                        </el-checkbox>
                      </el-checkbox-group>
                    </div>
                  </el-form-item>

                  <el-form-item label="购机价格">
                    <el-checkbox-group v-model="selectedPrices">
                      <el-checkbox v-for="(priceRange, index) in priceRanges" :key="priceRange.value"
                        :label="priceRange.value">
                        {{ priceRange.label }}
                      </el-checkbox>
                    </el-checkbox-group>
                  </el-form-item>
                </el-form>

                <!-- 第三个卡片内容 -->
                <el-form label-position="right" :model="formLabelAlign3">
                  <el-form-item label="展现形式:">
                    <el-cascader v-model="formLabelAlign3.placeType" :options="options4" filterable
                      @change="placeTypeChange">
                    </el-cascader>
                  </el-form-item>

                  <el-form-item label="标题打乱(默认打开):">
                    <el-switch v-model="daluan" active-color="#13ce66" inactive-color="#ff4949">
                    </el-switch>
                  </el-form-item>
                  <el-form-item label="投放位置:" style="text-align: left;">
                    <el-select v-model="virtualPositionvalue" multiple collapse-tags style="
    /* margin-left: 20px; */
    width: 100%;
    min-width: 200px;
    max-width: 300px;
  " :style="{
    'flex': '1',
    'min-width': isMobile ? '200px' : '300px'
  }" placeholder="请选择">
                      <el-option v-for="item in virtualPositionoptions" :key="item.virtualPositionUuid"
                        :label="item.virtualPositionName" :value="item.virtualPositionUuid">
                      </el-option>
                    </el-select>
                  </el-form-item>

                  <!--                  <el-form-item label="*产品名:" style="margin-top: 20px">-->
                  <!--                    <el-input style="width: 200px;" v-model="formLabelAlign3.productName"></el-input>-->
                  <!--                  </el-form-item>-->
                  <div v-for="(product, index) in formLabelAlign3.productNames" :key="index" class="product-input">
                    <el-form-item :label="'*产品名 ' + (index + 1) + ':'" style="margin-top: 20px">
                      <el-input v-model="formLabelAlign3.productNames[index]" style="width: 200px;"></el-input>
                      <el-button v-if="formLabelAlign3.productNames.length > 1" @click="removeProduct(index)"
                        type="danger" size="mini">
                        删除
                      </el-button>
                    </el-form-item>
                    <!-- 删除按钮 -->

                  </div>

                  <!-- 添加产品名按钮 -->
                  <el-button @click="addProduct" type="primary" size="small" style="margin-top: 20px;">
                    添加产品名
                  </el-button>

                  <el-form-item :label="'标题：' + formLabelAlign3.title.length + '个'" style="margin-top: 20px">
                    <el-input type="textarea" style="width: 440px;" v-model="titlesString" placeholder="请输入标题（每行一个）"
                      :rows="9" @input="handleInput"></el-input>
                    <!-- 显示超出字符限制的行提示 -->
                    <div v-for="(line, index) in linesWithLimitError" :key="index"
                      style="color: red; font-size: 12px; margin-top: 5px;">
                      第{{ index + 1 }}行超出字符限制（最多 {{ maxLength }} 字）：{{ line }}
                    </div>
                  </el-form-item>



                  <el-form-item label="撞审标题：" style="margin-top: 20px">
                    <el-input type="textarea" style="width: 440px;" v-model="zstitlesString" placeholder="请输入撞审标题（每行一个）"
                      :rows="9" @input="zshandleInput"></el-input>
                    <!-- 显示超出字符限制的行提示 -->
                    <div v-for="(line, index) in zslinesWithLimitError" :key="index"
                      style="color: red; font-size: 12px; margin-top: 5px;">
                      <div>有</div>侧文案超出字符限制，最多 {{ maxLength }} 个字符：{{ line }}
                    </div>
                  </el-form-item>
                </el-form>




              </div>
            </el-card>
            <!--图片素材代码-->
            <el-card class="box-cards" style="height:15%;">
              <div slot="header" class="clearfix">
                <span>批量搭建任务进度</span>
              </div>
              <el-row>
                <el-progress style="width: 50%;margin:0 auto;" :text-inside="false" :stroke-width="26" status="success"
                  :percentage="percentages"></el-progress>
              </el-row>
              <!--          <el-dialog :visible.sync="dialogVisible">-->
              <!--            <img width="20%" :src="dialogImageUrl" alt="">-->
              <!--          </el-dialog>-->
            </el-card>
            <el-tabs class="box-card" v-model="updateType">
              <el-tab-pane label="头像" name="first">
                <el-card class="box-card" style="height:90%;overflow: auto;">
                  <div slot="header" class="clearfix">
                    <span>注意辨别是否需要头像</span>
                  </div>
                  <el-row>
                    <el-upload ref='upload' :multiple="true" action="#" scoped-slot="text" list-type="picture-card"
                      :on-preview="txhandlePictureCardPreview" :auto-upload="false" :file-list="txfileList"
                      :on-change='txonChange' :on-remove="txhandleRemove">
                      <i class="el-icon-plus test"></i>
                    </el-upload>
                    <el-tag>素材上传进度</el-tag>
                    <el-progress style="width: 50%;margin:0 auto;" :text-inside="false" :stroke-width="26"
                      status="success" :percentage="percentage"></el-progress>
                  </el-row>
                  <!--                  <el-button type="primary"  @click="clearfile" size="small">一键清除</el-button>-->
                </el-card>
              </el-tab-pane>

              <el-tab-pane label="图片" name="second">
                <el-card class="box-card" style="height:90%;overflow: auto;">
                  <div slot="header" class="clearfix">
                    <span>素材上传工作区</span>
                  </div>
                  <el-row>
                    <el-upload ref='upload' :multiple="true" action="#" scoped-slot="text" list-type="picture-card"
                      :on-preview="handlePictureCardPreview" :auto-upload="false" :file-list="fileList"
                      :on-change='onChange' :on-remove="handleRemove">
                      <i class="el-icon-plus test"></i>
                    </el-upload>
                    <el-tag>素材上传进度</el-tag>
                    <el-progress style="width: 50%;margin:0 auto;" :text-inside="false" :stroke-width="26"
                      status="success" :percentage="percentage"></el-progress>
                  </el-row>
                  <!--                  <el-button type="primary"  @click="clearfile" size="small">一键清除</el-button>-->
                </el-card>
              </el-tab-pane>
              <el-tab-pane label="视频" name="third">
                <el-card class="box-card" style="height:90%;">
                  <div slot="header" class="clearfix">
                    <span>视频素材上传工作区</span>
                  </div>
                  <el-row>
                    <el-upload ref='upload12' :multiple="true" action="#" scoped-slot="text"
                      :on-preview="handlePictureCardPreview2" :auto-upload="false" :file-list="VideofileList"
                      :on-change='onChange2' :on-remove="handleRemove2">
                      <i class="el-icon-plus test"></i>
                    </el-upload>
                    <el-tag>素材上传进度</el-tag>
                    <el-progress style="width: 50%;margin:0 auto;" :text-inside="false" :stroke-width="26"
                      status="success" :percentage="percentage"></el-progress>
                    <el-dialog :visible.sync="dialogVisible">
                      <img width="20%" :src="dialogImageUrl" alt="">
                    </el-dialog>
                  </el-row>
                  <!--                  <el-button type="primary"  @click="clearfile" size="small">一键清除</el-button>-->
                </el-card>
              </el-tab-pane>
              <el-tab-pane label="撞审图片" name="fourth">
                <el-card class="box-card" style="height:90%;">
                  <div slot="header" class="clearfix">
                    <span>撞审图片素材上传工作区</span>
                  </div>
                  <el-row>
                    <!--                    :limit="9"-->
                    <el-upload ref='upload' :multiple="true" action="#" scoped-slot="text" list-type="picture-card"
                      :on-preview="zshandlePictureCardPreview" :auto-upload="false" :file-list="zsfileList"
                      :on-change='zsonChange' :on-remove="zshandleRemove">
                      <i class="el-icon-plus test"></i>
                    </el-upload>
                    <el-tag>素材上传进度</el-tag>
                    <el-progress style="width: 50%;margin:0 auto;" :text-inside="false" :stroke-width="26"
                      status="success" :percentage="percentage"></el-progress>
                  </el-row>
                  <!--                  <el-button type="primary"  @click="zsclearfile" size="small">一键清除</el-button>-->
                </el-card>
              </el-tab-pane>

              <el-tab-pane label="撞审视频" name="fifth">
                <el-card class="box-card" style="height:90%;">
                  <div slot="header" class="clearfix">
                    <span>撞审视频素材</span>
                  </div>
                  <el-row>
                    <el-upload ref='zsupload12' :multiple="true" action="#" scoped-slot="text"
                      :on-preview="zshandlePictureCardPreview2" :auto-upload="false" :file-list="zsVideofileList"
                      :on-change='zsonChange2' :on-remove="zshandleRemove2">
                      <i class="el-icon-plus test"></i>
                    </el-upload>
                    <el-tag>素材上传进度</el-tag>
                    <el-progress style="width: 50%;margin:0 auto;" :text-inside="false" :stroke-width="26"
                      status="success" :percentage="percentage"></el-progress>
                    <el-dialog :visible.sync="zsdialogVisible">
                      <img width="20%" :src="zsdialogImageUrl" alt="">
                    </el-dialog>
                  </el-row>
                  <!--                  <el-button type="primary"  @click="zsclearfile" size="small">一键清除</el-button>-->
                </el-card>
              </el-tab-pane>
            </el-tabs>



            <el-dialog title="搭建数量详情" :visible.sync="advRecordDetailDialogVisible" width="70%">
              <!-- 当前日期总数 -->
              <div class="mb-2">
                <span class="font-bold">该日期总搭建数量：</span>
                <span class="text-lg text-success">{{ advRecordDetailTotal }}</span>
              </div>

              <!-- 表格 -->
              <el-table :data="advRecordDetailList" border style="width: 100%">
                <el-table-column prop="accountName" label="素材库名" />
                <el-table-column prop="accountCount" label="已创建数量" />
                <el-table-column prop="statDate" label="日期" />
              </el-table>
            </el-dialog>
          </el-main>

        </el-container>
      </el-container>
    </el-container>






  </div>
</template>

<script>
import axios from "axios";
import Decimal from "decimal.js";
import dayjs from "dayjs";


export default {
  data() {
    const cityOptions = [];
    const c1 = [{
      id: 25,
      value: '0-17岁'
    },
    {
      id: 26,
      value: '18-24岁'
    },
    {
      id: 27,
      value: '25-29岁'
    },
    {
      id: 28,
      value: '30-39岁'
    },
    {
      id: 29,
      value: '40-49岁'
    },
    {
      id: 30,
      value: '50岁及以上'
    },
    ]
    return {

      virtualPositionoptions: [],
      virtualPositionvalue: [],
      advRecordDetailDialogVisible: false,
      advRecordDetailList: [],
      advRecordDetailTotal: 0,
      advRecordQueryDate: this.getDefaultStatDate(), // 默认统计日
      advRecordTodayTotal: 0,
      advRecordTimer: null,
      currentNormalIndex: 0,
      currentReviewIndex: 0,
      txfileList: [],
      txfileCode: [],
      countdialogVisible: false,
      countformData: {
        normalCount: 0,
        reviewCount: 0
      },
      zsfileList: [],
      isoldgroupprice: false,
      oldGroupPrice: '',
      newplanflag: false,
      ePlanId: '',
      linesWithLimitError: [], // 存储超出字符限制的行
      zslinesWithLimitError: [], // 存储超出字符限制的行
      maxLength: 26, // 默认最大字符数
      timeRanges: [{ start: '00:00', end: '24:00' }],
      isguanz: false,
      stopAll: false,
      titlesString: '',
      zstitlesString: '',
      zstitleList: [],

      categoryName: '',
      beSelectCategory: null,
      categoryList: [],

      // 可选的分类数据
      categories: [
        { categoryName: '星光剧场-男频', categoryId: 2917, categoryUid: 'b79d4d58dc196dd941f8', categoryUtoken: '43f9d1624140e71944945eb06d77dbb5739fe597148faae039887aaa9fbf0f59' },
        { categoryName: '星光剧场-女频', categoryId: 3148, categoryUid: 'b79d4d58dc196dd941f8', categoryUtoken: 'd7408c1fda253deabbc079a42e7e3e4590213f1a4d2cac7e786c5761ff84ab2d' },
        { categoryName: '小说阅读', categoryId: 2725, categoryUid: '3a05d5cac153d5b5b571', categoryUtoken: '6a5de1e302a7d78703b33d406aae6216f28d05059f026e6c0b70daf3b916bffc' },
        { categoryName: '梦享剧场', categoryId: 2700, categoryUid: '1ed11a001527004c7013', categoryUtoken: 'aa5e70199f4bfb02ff782f76564ba2d1e86623f63b3133cb56fcfb0d11fa93a9' },
        { categoryName: '小说大全', categoryId: 2910, categoryUid: 'b14dde881a82e006f4d3', categoryUtoken: '6a5de1e302a7d78703b33d406aae6216f28d05059f026e6c0b70daf3b916bffc' },
        { categoryName: '繁花剧场', categoryId: 3082, categoryUid: '68fb22cb1d92c8ac37b0', categoryUtoken: 'd7408c1fda253deabbc079a42e7e3e4590213f1a4d2cac7e786c5761ff84ab2d' },
      ],

      sucaikus: [
        { uname: '夏夏-素材库', uid: '905691a79178d513615f', utoken: 'cedffa4bd473d9e6b7920fa5c84ee802fb0d272b58244b21fb52d77a68cc4d48' },


        { uname: '踏歌行cid', uid: '0096318ee8a63f48e03c', utoken: 'ba90ae9dfa8f00be7d0bea25919c2d6f74b7e3c2436f41c16aa109b59653e70a' },
        { uname: '静静-素材库', uid: 'e0c74645da685987e716', utoken: 'cedffa4bd473d9e6b7920fa5c84ee802fb0d272b58244b21fb52d77a68cc4d48' },
        { uname: '名名-素材库', uid: '59a00ca6ee83961f5dc1', utoken: 'cedffa4bd473d9e6b7920fa5c84ee802fb0d272b58244b21fb52d77a68cc4d48' },
        { uname: '建建-素材库', uid: '691987694b1f6053ebe5', utoken: 'cedffa4bd473d9e6b7920fa5c84ee802fb0d272b58244b21fb52d77a68cc4d48' },

        { uname: '多笙五', uid: '88b10eca7ec87f049cd1', utoken: 'c36cc6eac785a5bc0072da7a947e5dc2df4442bb86b1be4421bec1d79818932d' },
        { uname: '吕吕-素材库', uid: '07f29cc112584da274aa', utoken: '3fe688be3bbd807f93970353db4c677c10a57ae42e58b221a8b5a4f883a78b05' },
        { uname: '苏苏-素材库', uid: '6acb6b91dfeecae05fe6', utoken: '3fe688be3bbd807f93970353db4c677c10a57ae42e58b221a8b5a4f883a78b05' },
        { uname: '唐唐-素材库', uid: '5d397dd38ed90e51c569', utoken: '3fe688be3bbd807f93970353db4c677c10a57ae42e58b221a8b5a4f883a78b05' },
        { uname: '虞虞-素材库', uid: '84e73803a24cc98c202f', utoken: '3fe688be3bbd807f93970353db4c677c10a57ae42e58b221a8b5a4f883a78b05' },
        { uname: 'LY-素材库', uid: '129430d5a3c8dd72b7f3', utoken: '2953098b38e557b07dcfc49c3273bcfb0031a73adf389dbc0b633ef9ce1f21bf' },
        { uname: '金顶', uid: '9e2a5afc6a4f1951aa61', utoken: '3f4e99a46f245386d00544168b1e33cc3a23bfda59af3bc798001c78568758e0' },
        { uname: '踏歌行白酒', uid: '60c7e7999bd7624498ad', utoken: 'ba90ae9dfa8f00be7d0bea25919c2d6f74b7e3c2436f41c16aa109b59653e70a' },
        { uname: '踏歌行气血酒', uid: 'ae7580b279968b5c4797', utoken: '5c57f68b1bd0e2d692556848c6747f900fa64b420624009743e51b203460c7c8' },
        { uname: '万盒-素材库', uid: 'e596fe8ac11184caa7a8', utoken: 'bce01c5391d1b3e68696158dd308dd888cb0d66ce3169b1957a6ad4509318b39' },
        // { uname: '陈慧', uid: 'a28c5beba2b6c64119e3', utoken: '71c85b5fac0942397e50ee71e0b7f727df69c173fab181b2b160dd477c2a822a' },，


        // { uname: '陈慧', uid: 'a28c5beba2b6c64119e3', utoken: '71c85b5fac0942397e50ee71e0b7f727df69c173fab181b2b160dd477c2a822a' },

      ],
      zjcookie: '',
      sucainame: '', // 存储选中的素材名称
      selectedsucaiku: null,// 存储选中的完整对象
      selectedCategoryName: '', // 存储选中的分类名称
      selectedCategory: null,// 存储选中的完整对象
      priceRanges: [
        { label: '>4500', value: 1530022 },
        { label: '4000~4500', value: 1530021 },
        { label: '3500~4000', value: 1530020 },
        { label: '3000~3500', value: 1530019 },
        { label: '2500~3000', value: 1530018 },
        { label: '2000~2500', value: 1530017 },
        { label: '1500~2000', value: 1530016 },
        { label: '1000~1500', value: 1530015 },
        { label: '0~1000', value: 1530014 }
      ],
      // 默认勾选所有购机价格区间ID
      selectedPrices: [
        1530014, 1530022, 1530021, 1530020, 1530019,
        1530018, 1530017, 1530016, 1530015
      ],
      // 定义安卓版本和对应的值
      androidVersions: [
        { label: '安卓4及以下', value: 1650003 },
        { label: '安卓5', value: 1650004 },
        { label: '安卓6', value: 1650005 },
        { label: '安卓7', value: 1650006 },
        { label: '安卓8', value: 1650007 },
        { label: '安卓9', value: 1650008 },
        { label: '安卓10', value: 1650001 },
        { label: '安卓11', value: 1650002 },
        { label: '安卓12', value: 1650009 },
        { label: '安卓13', value: 1650010 },
        { label: '安卓14', value: 1650011 },
        { label: '安卓15', value: 1650012 },
        { label: '安卓16及以上', value: 1650013 }
      ],
      // 默认勾选所有的安卓版本值
      selectedVersions: [1650001, 1650002, 1650003, 1650004, 1650005, 1650006, 1650007, 1650008, 1650009, 1650010, 1650011, 1650012, 1650013],

      androidVersionSetList: [],
      phonePriceSetList: [],
      beSelectAdType: '', // 被选中的广告类型
      adTypeList: [
        { label: '网址', value: 1 },
        { label: '快应用', value: 8 },
        { label: '小程序', value: 11 }
      ],
      myAdType: '',
      customList2: '',
      customListpc: '',
      customListrqb: [],
      customListrqbpc: [],
      erjihangye: [],
      options5: [
        {
          value: '2100018',
          label: '电商',
          children: [{
            value: '2220145',
            label: '优惠券'
          },
          {
            value: '2220142',
            label: '综合电商平台'
          },

          ]
        },



        {
          value: '2100024',
          label: '系统/工具',
          children: [
            {
              value: '2220196',
              label: '体育健康'
            }, {
              value: '2220202',
              label: '日常工具'
            }, {
              value: '2220200',
              label: '天气日历'
            }, {
              value: '2220195',
              label: '系统软件  '
            },



          ]
        },


        {
          value: '2100009',
          label: '出版经营',
          children: [{
            value: '2220037',
            label: '出版物'
          }]
        },
        {
          value: '2100019',
          label: '直营电商',
          children: [
            {
              value: '2220148',
              label: '数码家电'
            },
            {
              value: '2220158',
              label: '物品收藏'
            },
            {
              value: '2220149',
              label: '日用百货'
            },
            {
              value: '2220155',
              label: '个护美妆'
            },
            {
              value: '2220154',
              label: '其他'
            },
            {
              value: '2220159',
              label: '医药保健'
            },
            {
              value: '2220157',
              label: '零食饮料'
            },
            {
              value: '2220147',
              label: '服饰鞋包'
            },
          ]
        },

        {
          value: '2100013',
          label: '生活服务',
          children: [{
            value: '2220099',
            label: '综合生活服务'
          },]
        },
        {
          value: '2100023',
          label: '娱乐影视',
          children: [{
            value: '2220193',
            label: '小说平台'
          }, {
            value: '2220187',
            label: '视频'
          }, {
            value: '2220192',
            label: '段子漫画'
          },]
        },
        {
          value: '2100012',
          label: '医疗服务',
          children: [
            {
              value: '2220064',
              label: '医疗器械'
            },
            {
              value: '2220072',
              label: '保健用品'
            },
            {
              value: '2220063',
              label: '医疗科室'
            },
            {
              value: '2220070',
              label: '药品'
            },
            {
              value: '2220075',
              label: '医疗线上咨询平台'
            }



          ]
        },

        {
          value: '2100020',
          label: '教育',
          children: [{
            value: '2220162',
            label: '素质教育'
          }, {
            value: '2220161',
            label: '理财培训'
          },{
            value: '2220165',
            label: '语言培训'
          },]
        },
        {
          value: '2100011',
          label: '食品',
          children: [{
            value: '2220046',
            label: '散装食品'
          },
          {
            value: '2220045',
            label: '包装食品饮料'
          },
          {
            value: '2220062',
            label: '保健食品'
          },
          {
            value: '2220048',
            label: '酒品'
          }, {
            value: '2220061',
            label: '有机食品'
          },]
        },
        {
          value: '2100029',
          label: '金融',
          children: [{
            value: '2220260',
            label: '保险'
          },
            {
              value: '2220256',
              label: '证券/股票'
            },
            {
              value: '2220254',
              label: '贷款'
            },

            {
              value: '2220259',
              label: '第三方支付平台'
            },

          ]
        },
        // {
        //   value: 2220187,
        //   label: '视频',
        // },{
        //   value: 2220193,
        //   label: '小说平台',
        // },
      ],
      sex: '不限',
      customList: [1247469, 1247470, 1223942],
      age: [],
      sexList: [],

      zzIdList: [],
      ageIdList: [],
      ages: c1,
      regionCodeList: [
        '110000',
        '120000',
        '130000',
        '140000',
        '150000',
        '210000',
        '220000',
        '230000',
        '310000',
        '320000',
        '330000',
        '340000',
        '350000',
        '360000',
        '370000',
        '410000',
        '420000',
        '510000',
        '430000',
        '440000',
        '450000',
        '460000',
        '500000',
        '520000',
        '530000',
        '540000',
        '610000',
        '620000',
        '630000',
        '640000',
        '650000',
      ],
      flag: false,
      updateType: '',
      listname: [],
      time_list: '',
      timeList: [
        {
          value: '111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111',
          label: '全天投放'
        },
        {
          value: '000000000011111111111111111111111111111111111111000000000011111111111111111111111111111111111111000000000011111111111111111111111111111111111111000000000011111111111111111111111111111111111111000000000011111111111111111111111111111111111111000000000011111111111111111111111111111111111111000000000011111111111111111111111111111111111111',
          label: '五点'
        },
        {
          value: '000000000000111111111111111111111111111111111111000000000000111111111111111111111111111111111111000000000000111111111111111111111111111111111111000000000000111111111111111111111111111111111111000000000000111111111111111111111111111111111111000000000000111111111111111111111111111111111111000000000000111111111111111111111111111111111111',
          label: '六点'
        },
        {
          value: '000000000000001111111111111111111111111111111111000000000000001111111111111111111111111111111111000000000000001111111111111111111111111111111111000000000000001111111111111111111111111111111111000000000000001111111111111111111111111111111111000000000000001111111111111111111111111111111111000000000000001111111111111111111111111111111111',
          label: '七点'
        },
        {
          value: '000000000000000001111111111111111111111111111111000000000000000001111111111111111111111111111111000000000000000001111111111111111111111111111111000000000000000001111111111111111111111111111111000000000000000001111111111111111111111111111111000000000000000001111111111111111111111111111111000000000000000001111111111111111111111111111111',
          label: '八点半'
        },
        {
          value: '000000000000000000111111111111111111111111111111000000000000000000111111111111111111111111111111000000000000000000111111111111111111111111111111000000000000000000111111111111111111111111111111000000000000000000111111111111111111111111111111000000000000000000111111111111111111111111111111000000000000000000111111111111111111111111111111',
          label: '九点后'
        },
        {
          value: '000000000000000000011111111111111111111111111111000000000000000000011111111111111111111111111111000000000000000000011111111111111111111111111111000000000000000000011111111111111111111111111111000000000000000000011111111111111111111111111111000000000000000000011111111111111111111111111111000000000000000000011111111111111111111111111111',
          label: '九点半'
        },
        {
          value: '000000000000000000001111111111111111111111111111000000000000000000001111111111111111111111111111000000000000000000001111111111111111111111111111000000000000000000001111111111111111111111111111000000000000000000001111111111111111111111111111000000000000000000001111111111111111111111111111000000000000000000001111111111111111111111111111',
          label: '十点'
        },
        {
          value: '000000000000000000000111111111111111111111111111000000000000000000000111111111111111111111111111000000000000000000000111111111111111111111111111000000000000000000000111111111111111111111111111000000000000000000000111111111111111111111111111000000000000000000000111111111111111111111111111000000000000000000000111111111111111111111111111',
          label: '十点半'
        },
        {
          value: '000000000000000000000011111111111111111111111111000000000000000000000011111111111111111111111111000000000000000000000011111111111111111111111111000000000000000000000011111111111111111111111111000000000000000000000011111111111111111111111111000000000000000000000011111111111111111111111111000000000000000000000011111111111111111111111111',
          label: '十一点'
        }, {
          value: '000000000000000000000000000011111111111111111111000000000000000000000000000011111111111111111111000000000000000000000000000011111111111111111111000000000000000000000000000011111111111111111111000000000000000000000000000011111111111111111111000000000000000000000000000011111111111111111111000000000000000000000000000011111111111111111111',
          label: '十四点'
        },
        {
          value: '000000000000000000000000000000001111111111111111000000000000000000000000000000001111111111111111000000000000000000000000000000001111111111111111000000000000000000000000000000001111111111111111000000000000000000000000000000001111111111111111000000000000000000000000000000001111111111111111000000000000000000000000000000001111111111111111',
          label: '十六点'
        },
        {
          value: '000000000000000000000000000000000011111111111111000000000000000000000000000000000011111111111111000000000000000000000000000000000011111111111111000000000000000000000000000000000011111111111111000000000000000000000000000000000011111111111111000000000000000000000000000000000011111111111111000000000000000000000000000000000011111111111111',
          label: '十七点'
        },
        {
          value: '000000000000000000000000000000000000111111111111000000000000000000000000000000000000111111111111000000000000000000000000000000000000111111111111000000000000000000000000000000000000111111111111000000000000000000000000000000000000111111111111000000000000000000000000000000000000111111111111000000000000000000000000000000000000111111111111',
          label: '十八点'
        }],
      names: '',
      idsname: [],

      option1: [{
        value: '1',
        label: '非应用商店'
      },
      {
        value: '2',
        label: '广告联盟'
      }],

      options3: [{
        value: '4',
        label: '表单提交'
      }, {
        value: '5',
        label: '自定义激活'
      }, {
        value: '7',
        label: '添加到桌面'
      }, {
        value: '12',
        label: '自定义付费'
      },
      {
        value: '13',
        label: '自定义拉活'
      },
      {
        value: '52',
        label: '快应用/快游戏ROI1-广告变现'
      }],
      flag1: true,
      flag2: true,
      options4: [{
        value: '1',
        label: '信息流',
        children: [{
          value: '62',
          label: '横板大图',
        },
        {
          value: '63',
          label: '竖版大图',
        },
        {
          value: '4',
          label: '组图',
        },
        {
          value: '3',
          label: '小图',
        }, {
          value: '61',
          label: '横板视频'
        }, {
          value: '75',
          label: '竖版视频'
        }]
      },

      {
        value: '2',
        label: '开屏',
        children: [
          {
            value: '35',
            label: '竖版大图',
          },
          {
            value: '85',
            label: '横版大图',
          },


        ]
      },
      //   {
      //   value: '2',
      //   label: '开屏'
      // },{
      //   value: '3',
      //   label: 'banner'
      // },
      {
        value: '5',
        label: '原生广告',
        children: [{
          value: '48',
          label: '横板大图',
        },
        {
          value: '209',
          label: '竖版大图',
        },
        {
          value: '4',
          label: '组图',
        },
        {
          value: '121',
          label: '小图',
        }
          , {
          value: '242',
          label: '竖版视频',
        },
        {
          value: '122',
          label: '横版视频',
        },

        ]
      },
      {
        value: '4',
        label: '插屏',
        children: [
          {
            value: '39',
            label: '竖版大图(780*800)',
          },
          // {
          //   "displayName": "竖版大图",
          //   "dtoList": [
          //     {
          //       "displayType": 4,
          //       "titleLength": 0,
          //       "fileSize": 50,
          //       "id": 39,
          //       "fileType": "1,2",
          //       "displayMode": 4,
          //       "dimensions": "780*800"
          //     },
          //     {
          //       "displayType": 4,
          //       "titleLength": 26,
          //       "fileSize": 300,
          //       "id": 207,
          //       "fileType": "1,2",
          //       "displayMode": 1,
          //       "dimensions": "1080*1920"
          //     }
          //   ],
          //   "displayMode": 10001
          // },
          // {
          //   "displayName": "横版大图",
          //   "dtoList": [
          //     {
          //       "displayType": 4,
          //       "titleLength": 26,
          //       "fileSize": 300,
          //       "id": 208,
          //       "fileType": "1,2",
          //       "displayMode": 1,
          //       "dimensions": "1280*720"
          //     }
          //   ],
          //   "displayMode": 10000
          // },
          // {
          //   "displayName": "竖版视频",
          //   "dtoList": [
          //     {
          //       "displayType": 4,
          //       "titleLength": 8,
          //       "fileSize": 51200,
          //       "id": 145,
          //       "fileType": "1,2,6",
          //       "displayMode": 10,
          //       "dimensions": "720*1280"
          //     }
          //   ],
          //   "displayMode": 10010
          // },
          // {
          //   "displayName": "横版视频",
          //   "dtoList": [
          //     {
          //       "displayType": 4,
          //       "titleLength": 8,
          //       "fileSize": 51200,
          //       "id": 142,
          //       "fileType": "1,2,6",
          //       "displayMode": 5,
          //       "dimensions": "1280*720"
          //     }
          //   ],
          //   "displayMode": 10005
          // }

        ]
      }
      ],
      accounts: '',

      daluan: true,
      value: '',
      formLabelAlign: {
        name: '',
        mediaType: '',
        dailyBudget: ''
      },
      formLabelAlign1: {
        name: '',
        cvType: '',
        ocpxPrice: ''
      },
      normId: [61, 4, 3],
      formLabelAlign3: {
        placeType: '',
        title: [],
        productNames: [''],
      },
      percentage: 0,
      percentages: 0,
      fileList: [],
      VideofileList: [],
      zsVideofileList: [],

      creativeList: [],
      arr: {},
      idsList: [
        {
          id: '',
          username: '',
          ids: '',
          twoname: '',
          url: '',
          xiaoshuourl: '',
          baoguangurl: '',
          token: '',
          idsname: '',
          planId: '',
          groundId: '',
          planName: ''
        }
      ],
      dialogImageUrl: '',
      zsdialogImageUrl: '',
      dialogVisible: false,
      zsdialogVisible: false,
      fileCode: [],
      zsfileCode: [],
      zsvideofileCode: [],
      videofileCode: [],
      two: [{
        id: '',
        twoname: '',
      }],
      // towToken:[],
      towName: '',
      username: '',
      advertiseQualificationId: '', // 资质id
      beSelectDiYu: '',
      beSelectMap: {},
      // 存储定向的
      mapArray: [
        {
          name: "不限",
          map: {
            region: {
              regionCodeList: [
                110000,
                120000,
                130000,
                140000,
                150000,
                210000,
                220000,
                230000,
                310000,
                320000,
                330000,
                340000,
                350000,
                360000,
                370000,
                410000,
                420000,
                430000,
                440000,
                450000,
                460000,
                500000,
                510000,
                520000,
                530000,
                540000,
                610000,
                620000,
                630000,
                640000,
                650000,
                810000,
                820000
              ], // 地区编码列表
              stayType: 2 // 停留类型
            },
          }
        },
        {
          name: "速盟",
          map: {
            region: {
              regionCodeList: [
                120000,
                130000,
                140000,
                150000,
                210000,
                220000,
                230000,
                320200,
                320300,
                320400,
                320500,
                320600,
                320700,
                320800,
                320900,
                321000,
                321100,
                321200,
                321300,
                330200,
                330300,
                330400,
                330500,
                330600,
                330700,
                330800,
                330900,
                331000,
                331100,
                340000,
                350000,
                360000,
                370000,
                410000,
                420000,
                430000,
                440200,
                440400,
                440500,
                440700,
                440800,
                440900,
                441200,
                441300,
                441400,
                441500,
                441600,
                441700,
                441800,
                442099,
                445100,
                445200,
                445300,
                450000,
                460000,
                500000,
                510000,
                520000,
                530000,
                540000,
                610000,
                620000,
                630000,
                640000,
                650000,
                710199,
                810000,
                820000
              ],// 地区编码列表
              stayType: 2 // 停留类型
            },
          }
        },
        {
          name: "码力连",
          map: {
            region: {
              regionCodeList: [
                120000,
                130000,
                140200,
                140300,
                140400,
                140500,
                140600,
                140700,
                140800,
                140900,
                141000,
                141100,
                150000,
                210000,
                220000,
                230000,
                320200,
                320300,
                320500,
                320600,
                320700,
                320800,
                320900,
                321000,
                321100,
                321200,
                321300,
                330200,
                330300,
                330400,
                330500,
                330600,
                330700,
                330800,
                330900,
                331000,
                340000,
                350100,
                350300,
                350400,
                350500,
                350600,
                350700,
                350900,
                360000,
                370000,
                410000,
                420000,
                430000,
                440200,
                440400,
                440500,
                440600,
                440700,
                440800,
                441200,
                441400,
                441500,
                441600,
                441700,
                441800,
                442099,
                445100,
                445200,
                445300,
                450000,
                460000,
                510300,
                510400,
                510500,
                510600,
                510700,
                510800,
                510900,
                511000,
                511100,
                511300,
                511400,
                511500,
                511600,
                511700,
                511800,
                511900,
                512000,
                513200,
                513300,
                513400,
                520000,
                530000,
                540000,
                610200,
                610300,
                610400,
                610500,
                610600,
                610700,
                610800,
                610900,
                611000,
                620000,
                630000,
                640000,
                650000,
                710199,
                810000,
                820000
              ],// 地区编码列表
              stayType: 2 // 停留类型
            },
          }
        },
        {
          name: "踏歌行气血酒",
          map: {
            region: {
              regionCodeList: [
                110000,
                120000,
                130000,
                140000,
                150000,
                210000,
                220000,
                230000,
                320000,
                330000,
                340000,
                350000,
                360000,
                370000,
                410000,
                420000,
                430000,
                440000,
                450000,
                460000,
                500000,
                510000,
                520000,
                530000,
                540000,
                610000,
                620000,
                630000,
                640000,
                650000,
                710199,
                810000,
                820000
              ], // 地区编码列表
              stayType: 2 // 停留类型
            },
          }
        },
        {
          name: "鸿途",
          map: {
            region: {
              regionCodeList:[
                120000,
                130000,
                140200,
                140300,
                140400,
                140500,
                140600,
                140700,
                140800,
                140900,
                141000,
                141100,
                150000,
                210000,
                220000,
                230000,
                320200,
                320300,
                320500,
                320600,
                320700,
                320800,
                320900,
                321000,
                321100,
                321200,
                321300,
                330200,
                330300,
                330400,
                330500,
                330600,
                330700,
                330800,
                330900,
                331000,
                340000,
                350100,
                350300,
                350400,
                350500,
                350600,
                350700,
                350800,
                350900,
                360100,
                360200,
                360300,
                360400,
                360500,
                360600,
                360700,
                360800,
                360900,
                361000,
                370100,
                370200,
                370300,
                370400,
                370500,
                370600,
                370700,
                370800,
                371000,
                371100,
                371300,
                371400,
                371500,
                371600,
                371700,
                410000,
                420000,
                430000,
                440200,
                440400,
                440500,
                440600,
                440700,
                440800,
                441200,
                441300,
                441400,
                441500,
                441600,
                441700,
                441800,
                442099,
                445100,
                445200,
                445300,
                450000,
                460200,
                460399,
                460499,
                469069,
                469070,
                469071,
                469072,
                469073,
                469074,
                469075,
                469076,
                469077,
                469078,
                469092,
                469093,
                469094,
                469097,
                469098,
                510300,
                510400,
                510500,
                510600,
                510700,
                510800,
                510900,
                511000,
                511100,
                511300,
                511400,
                511500,
                511600,
                511700,
                511800,
                511900,
                512000,
                513200,
                513300,
                513400,
                520100,
                520200,
                520400,
                520500,
                520600,
                522300,
                522600,
                522700,
                530000,
                540000,
                610200,
                610300,
                610400,
                610500,
                610600,
                610700,
                610800,
                610900,
                611000,
                620000,
                630000,
                640000,
                650000
              ],// 地区编码列表
              stayType: 2 // 停留类型
            },
          }
        },
        {
          name: "飞鱼",
          map: {
            region: {
              regionCodeList: [
                120000,
                130000,
                140000,
                150000,
                210000,
                220000,
                230000,
                320300,
                320400,
                320500,
                320600,
                320700,
                320800,
                320900,
                321000,
                321100,
                321200,
                321300,
                330200,
                330300,
                330400,
                330500,
                330600,
                330700,
                330800,
                330900,
                331000,
                331100,
                340000,
                350100,
                350300,
                350400,
                350500,
                350600,
                350700,
                350800,
                350900,
                360000,
                370000,
                410000,
                420200,
                420300,
                420500,
                420600,
                420700,
                420800,
                420900,
                421000,
                421100,
                421200,
                421300,
                422800,
                429078,
                429093,
                429094,
                429095,
                430000,
                440200,
                440400,
                440500,
                440600,
                440700,
                440800,
                440900,
                441200,
                441400,
                441500,
                441600,
                441700,
                441800,
                442099,
                445100,
                445200,
                445300,
                450000,
                460000,
                510300,
                510400,
                510500,
                510600,
                510700,
                510800,
                510900,
                511000,
                511100,
                511300,
                511400,
                511500,
                511600,
                511700,
                511800,
                511900,
                512000,
                513200,
                513300,
                513400,
                520000,
                530000,
                540000,
                610200,
                610300,
                610400,
              ],// 地区编码列表
              stayType: 2 // 停留类型
            },
          }
        },
        {
          name: "上海思珀",
          map: {
            region: {
              regionCodeList: [
                120000,
                130000,
                140200,
                140300,
                140400,
                140500,
                140600,
                140700,
                140800,
                140900,
                141000,
                141100,
                150000,
                210000,
                220000,
                230000,
                320200,
                320300,
                320500,
                320600,
                320700,
                320800,
                320900,
                321000,
                321100,
                321200,
                321300,
                330200,
                330300,
                330400,
                330500,
                330600,
                330700,
                330800,
                330900,
                331000,
                340000,
                350100,
                350300,
                350400,
                350500,
                350600,
                350700,
                350900,
                360000,
                370000,
                410000,
                420000,
                430000,
                440200,
                440400,
                440500,
                440600,
                440700,
                440800,
                441200,
                441400,
                441500,
                441600,
                441700,
                441800,
                442099,
                445100,
                445200,
                445300,
                450000,
                460000,
                510300,
                510400,
                510500,
                510600,
                510700,
                510800,
                510900,
                511000,
                511100,
                511300,
                511400,
                511500,
                511600,
                511700,
                511800,
                511900,
                512000,
                513200,
                513300,
                513400,
                520000,
                530000,
                540000,
                610200,
                610300,
                610400,
                610500,
                610600,
                610700,
                610800,
                610900,
                611000,
                620000,
                630000,
                640000,
              ],// 地区编码列表
              stayType: 2 // 停留类型
            },
          }
        },
        {
          name: "朝发vivo-华朝短剧",
          map: {
            region: {
              regionCodeList: [
                110000,
                120000,
                130000,
                140000,
                150000,
                210000,
                220000,
                230000,
                310000,
                320200,
                320300,
                320400,
                320500,
                320600,
                320700,
                320800,
                320900,
                321000,
                321100,
                321200,
                321300,
                330000,
                340000,
                350000,
                360000,
                370000,
                410000,
                420000,
                430000,
                440100,
                440200,
                440400,
                440500,
                440600,
                440700,
                440800,
                440900,
                441200,
                441300,
                441400,
                441500,
                441600,
                441700,
                441800,
                442099,
                445100,
                445200,
                445300,
                450000,
                460000,
                500000,
                510000,
                520000,
                530000,
                540000,
                610000,
                620000,
                630000,
                640000,
                650000,
                710199,
                810000,
                820000
              ],// 地区编码列表
              stayType: 2 // 停留类型
            },
          }
        },
        {
          name: "图书",
          map: {
            region: {
              regionCodeList: [
                110000,
                120000,
                130100,
                130400,
                130500,
                130700,
                130800,
                130900,
                131000,
                131100,
                140200,
                140400,
                140500,
                140600,
                140700,
                140800,
                140900,
                141000,
                141100,
                310000,
                330200,
                330300,
                330400,
                330500,
                330600,
                330800,
                330900,
                331000,
                420200,
                420300,
                420500,
                420600,
                420700,
                420800,
                420900,
                421000,
                421100,
                421200,
                421300,
                422800,
                429078,
                429093,
                429094,
                429095,
                430200,
                430400,
                430500,
                430700,
                430800,
                430900,
                431000,
                431100,
                431200,
                431300,
                433100,
                440200,
                440400,
                440500,
                440600,
                440700,
                440800,
                440900,
                441200,
                441300,
                441400,
                441500,
                441600,
                441700,
                441800,
                442099,
                445100,
                445200,
                445300,
                320000,
                340000,
                350000,
                360000,
                370000,
                450000,
                460000,
                510000,
                520000,
                530000,
                610000
              ], // 地区编码列表
              stayType: 2 // 停留类型
            },
          }
        },
        {
          name: "大圣壁纸",
          map: {
            region: {
              regionCodeList: [
                120000,
                320200,
                320300,
                320400,
                320500,
                320600,
                320700,
                320800,
                320900,
                321000,
                321100,
                321200,
                321300,
                440200,
                440400,
                440500,
                440600,
                440700,
                440800,
                440900,
                441200,
                441300,
                441400,
                441500,
                441600,
                441700,
                441800,
                442099,
                445100,
                445200,
                445300,
                500000,
                510300,
                510400,
                510500,
                510600,
                510700,
                510800,
                510900,
                511000,
                511100,
                511300,
                511400,
                511500,
                511600,
                511700,
                511800,
                511900,
                512000,
                513200,
                513300,
                513400,
                610200,
                610300,
                610400,
                610500,
                610600,
                610700,
                610800,
                610900,
                611000,
                130000,
                140000,
                150000,
                210000,
                220000,
                230000,
                330000,
                340000,
                350000,
                360000,
                370000,
                410000,
                420000,
                430000,
                450000,
                460000,
                520000,
                530000,
                540000,
                620000,
                630000,
                640000,
                650000
              ], // 地区编码列表
              stayType: 2 // 停留类型
            },
          }
        },
        {
          name: "朝发vivo",
          map: {
            region: {
              regionCodeList: [
                120000,
                320200,
                320300,
                320400,
                320500,
                320600,
                320700,
                320800,
                320900,
                321000,
                321100,
                321200,
                321300,
                330200,
                330300,
                330400,
                330500,
                330600,
                330700,
                330800,
                330900,
                331000,
                331100,
                350100,
                350300,
                350400,
                350500,
                350600,
                350700,
                350800,
                350900,
                440200,
                440400,
                440500,
                440600,
                440700,
                440800,
                441200,
                441300,
                441400,
                441500,
                441600,
                441700,
                441800,
                442099,
                445100,
                445200,
                445300,
                610200,
                610300,
                610400,
                610500,
                610600,
                610700,
                610800,
                610900,
                611000,
                710199,
                810000,
                820000,
                130000,
                140000,
                150000,
                210000,
                220000,
                230000,
                340000,
                360000,
                370000,
                410000,
                420000,
                430000,
                450000,
                460000,
                510000,
                520000,
                530000,
                540000,
                620000,
                630000,
                640000,
                650000
              ], // 地区编码列表
              stayType: 2 // 停留类型
            },
          }
        },
        {
          name: "帝江ROI",
          map: {
            region: {
              regionCodeList: [
                120000,
                130000,
                140200,
                140300,
                140400,
                140500,
                140600,
                140700,
                140800,
                141000,
                141100,
                150000,
                210000,
                220000,
                230000,
                320200,
                320300,
                320400,
                320500,
                320600,
                320700,
                320800,
                320900,
                321000,
                321100,
                321200,
                321300,
                330200,
                330300,
                330400,
                330500,
                330600,
                330700,
                330800,
                330900,
                331000,
                331100,
                340000,
                350100,
                350300,
                350400,
                350500,
                350600,
                350700,
                350800,
                350900,
                360000,
                370000,
                410000,
                420000,
                430000,
                440200,
                440400,
                440500,
                440600,
                440700,
                440800,
                440900,
                441200,
                441300,
                441400,
                441500,
                441600,
                441700,
                441800,
                442099,
                445100,
                445200,
                445300,
                450000,
                460000,
                510000,
                520000,
                530000,
                540000,
                610200,
                610300,
                610400,
                610500,
                610600,
                610700,
                610800,
                610900,
                611000,
                620000,
                630000,
                640000,
                650000
              ], // 地区编码列表
              stayType: 2 // 停留类型
            },
          }
        },
        {
          name: "帝江瑟瑟",
          map: {
            region: {

              regionCodeList: [
                120000,
                130000,
                140000,
                150000,
                210000,
                220000,
                230000,
                320200,
                320300,
                320400,
                320500,
                320600,
                320700,
                320800,
                320900,
                321000,
                321100,
                321200,
                321300,
                330000,
                340000,
                350100,
                350300,
                350400,
                350500,
                350600,
                350700,
                350800,
                350900,
                360000,
                370000,
                410000,
                420200,
                420300,
                420500,
                420600,
                420700,
                420800,
                420900,
                421000,
                421100,
                421200,
                421300,
                422800,
                429078,
                429093,
                429094,
                429095,
                430000,
                440200,
                440400,
                440500,
                440600,
                440700,
                440800,
                440900,
                441200,
                441400,
                441500,
                441600,
                441700,
                441800,
                442099,
                445100,
                445200,
                445300,
                450000,
                460000,
                510000,
                520000,
                530000,
                540000,
                610200,
                610300,
                610400,
                610500,
                610600,
                610700,
                610800,
                610900,
                611000,
                620000,
                630000,
                640000,
                650000
              ],
              stayType: 2 // 停留类型
            },
          }
        },
        {
          name: "爱测评投放地区xq",
          map: {
            region: {

              regionCodeList: [
                130000,
                140200,
                140300,
                140400,
                140500,
                140600,
                140700,
                140800,
                140900,
                141000,
                141100,
                150000,
                210000,
                220000,
                230000,
                320200,
                320300,
                320400,
                320500,
                320600,
                320700,
                320800,
                320900,
                321000,
                321200,
                321300,
                330200,
                330300,
                330400,
                330500,
                330700,
                330800,
                330900,
                331000,
                331100,
                340000,
                350100,
                350300,
                350400,
                350500,
                350600,
                350700,
                350800,
                350900,
                360000,
                370000,
                410000,
                420200,
                420300,
                420500,
                420600,
                420700,
                420800,
                420900,
                421000,
                421100,
                421200,
                421300,
                422800,
                429078,
                429093,
                429094,
                429095,
                430000,
                440200,
                440400,
                440500,
                440600,
                440700,
                440800,
                440900,
                441200,
                441300,
                441400,
                441500,
                441600,
                441700,
                441800,
                442099,
                445100,
                445200,
                445300,
                450000,
                460000,
                510000,
                520000,
                530000,
                540000,
                610200,
                610300,
                610400,
                610500,
                610600,
                610700,
                610800,
                610900,
                611000,
                620000,
                630000,
                640000,
                650000
              ],
              stayType: 2 // 停留类型
            },
          }
        },
        {
          name: "艾草枕批搭",
          map: {
            region: {

              regionCodeList: [
                110000,
                120000,
                130100,
                130200,
                130300,
                130800,
                130900,
                131000,
                131100,
                140100,
                140200,
                140300,
                140400,
                140500,
                140600,
                140700,
                140900,
                141000,
                141100,
                150100,
                150200,
                150300,
                150600,
                150700,
                150800,
                150900,
                310000,
                320000,
                330200,
                330300,
                330400,
                330500,
                330600,
                330700,
                330800,
                330900,
                331000,
                331100,
                340100,
                340200,
                340300,
                340500,
                340600,
                340700,
                340800,
                341000,
                341100,
                341700,
                341800,
                350000,
                360100,
                360200,
                360300,
                360400,
                360500,
                360600,
                360800,
                360900,
                361000,
                370100,
                370200,
                370300,
                370500,
                370600,
                370700,
                370800,
                370900,
                371000,
                371100,
                371400,
                371600,
                410100,
                410300,
                410600,
                411000,
                411100,
                411200,
                419098,
                420100,
                420200,
                420300,
                420500,
                420600,
                420700,
                420800,
                420900,
                421000,
                421200,
                421300,
                422800,
                429078,
                429093,
                429094,
                429095,
                430100,
                430200,
                430300,
                430400,
                430500,
                430600,
                430700,
                430800,
                430900,
                431000,
                440200,
                440400,
                440500,
                440600,
                440700,
                440800,
                440900,
                441200,
                441300,
                441400,
                441500,
                441600,
                441700,
                441800,
                442099,
                445100,
                445200,
                445300,
                450100,
                450200,
                450300,
                450400,
                450500,
                450600,
                450700,
                451400,
                460000,
                510100,
                510300,
                510400,
                510600,
                510700,
                510900,
                511100,
                511400,
                511500,
                511600,
                511800,
                520100,
                520300,
                530100,
                530300,
                530400,
                530500,
                530700,
                530900,
                610100,
                610200,
                610300,
                610400,
                610500,
                610600,
                610800,
                620100,
                620299,
                620300,
                620900,
                630100,
                640100,
                640200,
                640300,
                650100
              ],
              stayType: 2 // 停留类型
            },
          }
        },
        {
          name: "魔豆",
          map: {
            region: {

              regionCodeList: [
                120000,
                130000,
                140000,
                150000,
                210000,
                220000,
                230000,
                320000,
                330000,
                340000,
                350000,
                360000,
                370000,
                410000,
                420000,
                430000,
                440200,
                440400,
                440500,
                440600,
                440700,
                440800,
                440900,
                441200,
                441300,
                441400,
                441500,
                441600,
                441700,
                441800,
                442099,
                445100,
                445200,
                445300,
                450000,
                460000,
                500000,
                510000,
                520000,
                530000,
                540000,
                610000,
                620000,
                630000,
                640000,
                650000,
                710199,
                810000,
                820000
              ],
              stayType: 2 // 停留类型
            },
          }
        },
        {
          name: "悠漫步",
          map: {
            region: {
              regionCodeList: [
                120000,
                130000,
                140000,
                150000,
                210000,
                220000,
                230000,
                320200,
                320300,
                320500,
                320600,
                320700,
                320800,
                320900,
                321000,
                321100,
                321200,
                321300,
                330200,
                330300,
                330400,
                330500,
                330600,
                330700,
                330800,
                330900,
                331000,
                331100,
                340000,
                350300,
                350400,
                350500,
                350600,
                350700,
                350900,
                360000,
                370000,
                410000,
                420200,
                420300,
                420500,
                420600,
                420700,
                420800,
                420900,
                421000,
                421100,
                421200,
                421300,
                422800,
                429078,
                429093,
                429094,
                429095,
                430000,
                440200,
                440400,
                440500,
                440600,
                440700,
                440800,
                440900,
                441200,
                441300,
                441400,
                441500,
                441600,
                441700,
                441800,
                442099,
                445100,
                445200,
                445300,
                450000,
                460000,
                510300,
                510400,
                510500,
                510600,
                510700,
                510800,
                510900,
                511000,
                511100,
                511300,
                511400,
                511500,
                511600,
                511700,
                511800,
                511900,
                512000,
                513200,
                513300,
                513400,
                520000,
                530000,
                540000,
                610200,
                610300,
                610400,
                610500,
                610600,
                610700,
                610800,
                610900,
                611000,
                620000,
                630000,
                640000,
                650000
              ],// 地区编码列表
              stayType: 2 // 停留类型
            },
          }
        },
        {
          name: "追书",
          map: {
            region: {
              regionCodeList: [
                130000,
                140200,
                140300,
                140400,
                140500,
                140600,
                140700,
                140800,
                140900,
                141000,
                141100,
                150000,
                210000,
                220000,
                230000,
                320300,
                320400,
                320600,
                320700,
                320900,
                321000,
                321100,
                321200,
                321300,
                330200,
                330300,
                330400,
                330500,
                330600,
                330700,
                330800,
                330900,
                331000,
                331100,
                340000,
                350300,
                350400,
                350500,
                350600,
                350700,
                350800,
                350900,
                360000,
                370000,
                410000,
                420200,
                420300,
                420500,
                420600,
                420700,
                420800,
                420900,
                421000,
                421100,
                421200,
                421300,
                422800,
                429078,
                429093,
                429094,
                429095,
                430100,
                430200,
                430300,
                430400,
                430500,
                430600,
                430700,
                430800,
                430900,
                431000,
                431100,
                431200,
                431300,
                440200,
                440500,
                440600,
                440700,
                440800,
                440900,
                441200,
                441300,
                441400,
                441500,
                441600,
                441700,
                441800,
                442099,
                445100,
                445200,
                445300,
                450000,
                460000,
                510300,
                510400,
                510500,
                510600,
                510700,
                510800,
                510900,
                511000,
                511100,
                511300,
                511400,
                511500,
                511600,
                511700,
                511800,
                511900,
                512000,
                513200,
                513300,
                513400,
                520100,
                520200,
                520300,
                520400,
                520500,
                522300,
                522600,
                522700,
                530000,
                540000,
                610200,
                610300,
                610400,
                610500,
                610600,
                610700,
                610800,
                610900,
                611000,
                620000,
                630000,
                640000,
                650000
              ], // 地区编码列表
              stayType: 1 // 停留类型
            },
          }
        },
        {
          name: "福建追书",
          map: {
            region: {

              regionCodeList:
                [
                  120000,
                  130000,
                  140200,
                  140300,
                  140400,
                  140500,
                  140600,
                  140700,
                  140800,
                  140900,
                  141000,
                  141100,
                  150000,
                  210000,
                  220000,
                  230000,
                  320200,
                  320300,
                  320400,
                  320500,
                  320600,
                  320700,
                  320800,
                  320900,
                  321000,
                  321100,
                  321200,
                  321300,
                  330200,
                  330300,
                  330400,
                  330500,
                  330600,
                  330700,
                  330800,
                  330900,
                  331000,
                  340000,
                  350100,
                  350200,
                  350300,
                  350400,
                  350500,
                  350600,
                  350700,
                  350900,
                  360000,
                  370000,
                  410000,
                  420000,
                  430000,
                  440200,
                  440400,
                  440500,
                  440600,
                  440700,
                  440800,
                  441200,
                  441400,
                  441500,
                  441600,
                  441700,
                  441800,
                  442099,
                  445100,
                  445200,
                  445300,
                  450000,
                  460000,
                  510000,
                  520000,
                  530000,
                  540000,
                  610000,
                  620000,
                  630000,
                  640000,
                  650000,
                  710199,
                  810000,
                  820000
                ],// 地区编码列表
              stayType: 1 // 停留类型
            },
          }
        },
        {
          name: "诸云",
          map: {
            region: {
              regionCodeList: [
                130100,
                130200,
                130300,
                130400,
                130500,
                130600,
                130700,
                130800,
                130900,
                131100,
                140000,
                150000,
                210000,
                220000,
                230000,
                320200,
                320300,
                320500,
                320700,
                320800,
                320900,
                321000,
                321200,
                321300,
                330200,
                330300,
                330400,
                330500,
                330600,
                330700,
                330800,
                330900,
                331000,
                331100,
                340100,
                340300,
                340400,
                340500,
                340600,
                340700,
                340800,
                341000,
                341100,
                341200,
                341300,
                341500,
                341600,
                341700,
                341800,
                350300,
                350400,
                350500,
                350600,
                350700,
                350900,
                360000,
                370000,
                410000,
                420000,
                430000,
                440200,
                440400,
                440500,
                440700,
                440800,
                440900,
                441200,
                441300,
                441400,
                441500,
                441600,
                441700,
                441800,
                442099,
                445100,
                445200,
                445300,
                450000,
                460000,
                500000,
                510300,
                510400,
                510500,
                510600,
                510700,
                510800,
                510900,
                511000,
                511100,
                511300,
                511400,
                511500,
                511600,
                511700,
                511800,
                511900,
                512000,
                513200,
                513300,
                513400,
                520000,
                530000,
                540000,
                610200,
                610300,
                610400,
                610500,
                610600,
                610700,
                610800,
                610900,
                611000,
                620000,
                630000,
                640000,
                650000
              ], // 地区编码列表
              stayType: 1 // 停留类型
            },
          }
        },
        {
          name: "繁花剧场",
          map: {
            region: {
              regionCodeList: [
                110000,
                120000,
                130000,
                140000,
                150000,
                210000,
                220000,
                230000,
                310000,
                320000,
                330000,
                340000,
                350000,
                360000,
                370000,
                410000,
                420000,
                430000,
                440000,
                450000,
                460000,
                500000,
                510000,
                520000,
                530000,
                540000,
                610000,
                620000,
                630000,
                640000,
                650000
              ], // 地区编码列表
              stayType: 1 // 停留类型
            },
          }
        },

        {
          name: "肥猫小说",
          map: {
            region: {
              regionCodeList: [
                120000,
                130000,
                140000,
                150000,
                210000,
                220000,
                230000,
                320200,
                320300,
                320400,
                320500,
                320600,
                320700,
                320800,
                320900,
                321000,
                321100,
                321200,
                321300,
                330200,
                330300,
                330400,
                330500,
                330600,
                330700,
                330800,
                330900,
                331000,
                331100,
                340000,
                350100,
                350300,
                350400,
                350500,
                350600,
                350700,
                350800,
                350900,
                360000,
                370000,
                410000,
                420000,
                430000,
                440200,
                440400,
                440500,
                440600,
                440700,
                440800,
                440900,
                441200,
                441300,
                441400,
                441500,
                441600,
                441700,
                441800,
                442099,
                445100,
                445200,
                445300,
                450000,
                460000,
                510300,
                510400,
                510500,
                510600,
                510700,
                510800,
                510900,
                511000,
                511100,
                511300,
                511400,
                511500,
                511600,
                511700,
                511800,
                511900,
                512000,
                513200,
                513300,
                513400,
                520000,
                530000,
                540000,
                610200,
                610300,
                610400,
                610500,
                610600,
                610700,
                610800,
                610900,
                611000,
                620000,
                630000,
                640000,
                650000,
                710199,
                810000,
                820000
              ], // 地区编码列表
              stayType: 1 // 停留类型
            },
          }
        },
        {
          name: "生米",
          map: {
            region: {
              regionCodeList: [

                130000,
                140000,
                150000,
                210000,
                220000,
                230000,
                320200,
                320300,
                320400,
                320500,
                320600,
                320700,
                320800,
                320900,
                321000,
                321200,
                321300,
                330200,
                330300,
                330400,
                330500,
                330700,
                330800,
                330900,
                331000,
                331100,
                340000,

                350100,
                350300,
                350400,
                350500,
                350600,
                350700,
                350800,
                350900,
                360000,
                370000,
                410000,
                // 420000,
                420200, 420300, 420500, 420600, 420700, 420800, 420900, 421000, 421100, 421200, 421300, 422800, 429078, 429093, 429094, 429095,
                430000,
                440200,
                440400,
                440500,
                440600,
                440700,
                440800,
                440900,
                441200,
                441300,
                441400,
                441500,
                441600,
                441700,
                441800,
                442099,
                445100,
                445200,
                445300,
                450000,
                460000,
                510000,
                520000,
                530000,
                540000,
                610200,
                610300,
                610400,
                610500,
                610600,
                610700,
                610800,
                610900,
                611000,
                620000,
                630000,
                640000,
                650000,
                710199,
                810000,
                820000
              ], // 地区编码列表
              stayType: 1 // 停留类型
            },
          }
        },
        {
          name: "火苗",
          map: {
            region: {
              regionCodeList: [
                120000,
                130000,
                140000,
                150000,
                210000,
                220000,
                230000,
                320200,
                320300,
                320500,
                320600,
                320700,
                320800,
                320900,
                321000,
                321100,
                321300,
                330200,
                330300,
                330400,
                330500,
                330600,
                330700,
                330800,
                330900,
                331000,
                331100,
                340000,
                350100,
                350300,
                350400,
                350500,
                350600,
                350700,
                350800,
                350900,
                360100,
                360200,
                360300,
                360500,
                360600,
                360700,
                360800,
                360900,
                361000,
                370100,
                370200,
                370400,
                370500,
                370600,
                370700,
                370800,
                371000,
                371300,
                371400,
                371500,
                371600,
                371700,
                410000,
                420000,
                430100,
                430200,
                430300,
                430400,
                430500,
                430600,
                430700,
                430900,
                431000,
                431100,
                431200,
                431300,
                433100,
                440200,
                440400,
                440500,
                440600,
                440700,
                440800,
                440900,
                441200,
                441300,
                441400,
                441500,
                441600,
                441700,
                441800,
                442099,
                445100,
                445200,
                445300,
                450000,
                460000,
                510300,
                510400,
                510500,
                510600,
                510700,
                510800,
                510900,
                511100,
                511300,
                511400,
                511500,
                511600,
                511700,
                511800,
                511900,
                512000,
                513200,
                513300,
                513400,
                520000,
                530000,
                540000,
                610200,
                610300,
                610400,
                610500,
                610600,
                610700,
                610800,
                610900,
                611000,
                620000,
                630000,
                640000,
                650000,
                710199,
                810000,
                820000
              ]
              ,// 地区编码列表
              stayType: 1 // 停留类型
            },
          }
        },

        {
          name: "四组城市屏蔽",
          map: {
            region: {
              regionCodeList: [
                120000,
                130000,
                140200,
                140300,
                140400,
                140500,
                140600,
                140700,
                140800,
                140900,
                141000,
                141100,
                150000,
                210000,
                220000,
                230000,
                310000,
                320000,
                330200,
                330300,
                330400,
                330500,
                330600,
                330700,
                330800,
                330900,
                331000,
                331100,
                340000,
                350100,
                350300,
                350400,
                350500,
                350600,
                350700,
                350800,
                350900,
                360000,
                370000,
                410000,
                420200,
                420300,
                420500,
                420600,
                420700,
                420800,
                420900,
                421000,
                421100,
                421200,
                421300,
                422800,
                429078,
                429093,
                429094,
                429095,
                430000,
                440200,
                440400,
                440500,
                440600,
                440700,
                440800,
                440900,
                441200,
                441300,
                441400,
                441500,
                441600,
                441700,
                441800,
                442099,
                445100,
                445200,
                445300,
                450000,
                460000,
                500000,
                510000,
                520000,
                530000,
                540000,
                610000,
                620000,
                630000,
                640000,
                650000
              ]
              ,// 地区编码列表
              stayType: 1 // 停留类型
            },
          }
        },
        {
          name: "趣点",
          map: {
            region: {
              regionCodeList: [
                130000,
                140200,
                140300,
                140400,
                140500,
                140600,
                140700,
                140800,
                140900,
                141000,
                141100,
                150000,
                210000,
                220000,
                230000,
                320300,
                320500,
                320600,
                320700,
                320800,
                320900,
                321000,
                321200,
                321300,
                330200,
                330300,
                330400,
                330500,
                330700,
                330800,
                330900,
                331000,
                331100,
                340000,
                350300,
                350400,
                350500,
                350600,
                350700,
                350900,
                360000,
                370000,
                410000,
                420200,
                420300,
                420500,
                420600,
                420700,
                420800,
                420900,
                421000,
                421100,
                421200,
                421300,
                422800,
                429078,
                429093,
                429094,
                429095,
                430000,
                440200,
                440400,
                440500,
                440700,
                440800,
                440900,
                441200,
                441300,
                441400,
                441500,
                441600,
                441700,
                441800,
                442099,
                445100,
                445200,
                445300,
                450000,
                460000,
                510300,
                510400,
                510500,
                510600,
                510700,
                510800,
                510900,
                511000,
                511100,
                511300,
                511400,
                511500,
                511600,
                511700,
                511800,
                511900,
                512000,
                513200,
                513300,
                513400,
                520000,
                530000,
                540000,
                610200,
                610300,
                610400,
                610500,
                610600,
                610700,
                610800,
                610900,
                611000,
                620000,
                630000,
                640000,
                650000
              ]
              ,// 地区编码列表
              stayType: 1 // 停留类型
            },
          }
        },
        {
          name: "春河小说",
          map: {
            region: {
              regionCodeList: [
                130000,
                140000,
                150000,
                210000,
                220000,
                230000,
                320200,
                320400,
                320500,
                320600,
                320700,
                320800,
                321000,
                321100,
                321200,
                321300,
                330200,
                330300,
                330400,
                330500,
                330600,
                330700,
                330800,
                330900,
                331000,
                331100,
                350200,
                350300,
                350400,
                350500,
                350600,
                350700,
                350800,
                350900,
                360200,
                360300,
                360400,
                360500,
                360600,
                360700,
                360800,
                360900,
                361000,
                370200,
                370300,
                370400,
                370500,
                370600,
                370700,
                370800,
                370900,
                371000,
                371100,
                371400,
                371500,
                371600,
                410200,
                410300,
                410400,
                410500,
                410600,
                410800,
                410900,
                411000,
                411100,
                411200,
                411300,
                411400,
                411500,
                411600,
                411700,
                419098,
                420200,
                420300,
                420500,
                420600,
                420700,
                420800,
                420900,
                421000,
                421100,
                421200,
                421300,
                422800,
                429078,
                429093,
                429094,
                429095,
                430200,
                430300,
                430400,
                430500,
                430600,
                430700,
                430800,
                430900,
                431000,
                431100,
                431200,
                431300,
                433100,
                440200,
                440400,
                440500,
                440600,
                440700,
                440800,
                440900,
                441200,
                441300,
                441400,
                441500,
                441600,
                441700,
                441800,
                442099,
                445100,
                445200,
                445300,
                450000,
                460000,
                510300,
                510400,
                510500,
                510600,
                510700,
                510800,
                510900,
                511000,
                511100,
                511300,
                511400,
                511500,
                511600,
                511700,
                511800,
                511900,
                512000,
                513200,
                513300,
                513400,
                520000,
                530300,
                530400,
                530500,
                530600,
                530700,
                530800,
                530900,
                532300,
                532500,
                532600,
                532800,
                532900,
                533100,
                533300,
                533400,
                540000,
                610200,
                610300,
                610400,
                610500,
                610600,
                610700,
                610900,
                611000,
                620000,
                630000,
                640000,
                650000
              ]
              ,// 地区编码列表
              stayType: 1 // 停留类型
            },
          }
        },

        {
          name: "呱呱",
          map: {
            region: {
              regionCodeList: [
                130000,
                140000,
                150000,
                210000,
                220000,
                230000,
                320200,
                320300,
                320400,
                320600,
                320700,
                320800,
                320900,
                321000,
                321100,
                321200,
                321300,
                330300,
                330400,
                330500,
                330700,
                330800,
                330900,
                331000,
                331100,
                340200,
                340300,
                340400,
                340500,
                340600,
                340700,
                340800,
                341000,
                341100,
                341200,
                341300,
                341500,
                341600,
                341700,
                341800,
                350100,
                350300,
                350400,
                350500,
                350600,
                350700,
                350800,
                350900,
                360000,
                370300,
                370400,
                370500,
                370600,
                370700,
                370800,
                370900,
                371000,
                371100,
                371300,
                371400,
                371500,
                371600,
                371700,
                410000,
                420000,
                430200,
                430300,
                430400,
                430500,
                430600,
                430700,
                430800,
                430900,
                431000,
                431100,
                431200,
                431300,
                433100,
                440200,
                440400,
                440500,
                440700,
                440800,
                440900,
                441200,
                441300,
                441400,
                441500,
                441600,
                441700,
                441800,
                442099,
                445100,
                445200,
                445300,
                450000,
                460000,
                510300,
                510400,
                510500,
                510600,
                510700,
                510800,
                510900,
                511000,
                511100,
                511300,
                511400,
                511500,
                511600,
                511700,
                511800,
                511900,
                512000,
                513200,
                513300,
                513400,
                520000,
                530000,
                540000,
                610200,
                610300,
                610400,
                610500,
                610600,
                610700,
                610800,
                610900,
                611000,
                620000,
                630000,
                640000,
                650000,
                710199,
                810000,
                820000
              ]
              ,// 地区编码列表
              stayType: 1 // 停留类型
            },
          }
        },


        {
          name: "惟阅免费小说",
          map: {
            region: {
              regionCodeList: [
                130000,
                140000,
                150000,
                210000,
                220000,
                230000,
                320200,
                320300,
                320400,
                320600,
                320700,
                320800,
                320900,
                321000,
                321200,
                321300,
                330300,
                330400,
                330500,
                330700,
                330800,
                330900,
                331000,
                331100,
                340200,
                340300,
                340400,
                340500,
                340600,
                340700,
                340800,
                341000,
                341100,
                341200,
                341300,
                341500,
                341600,
                341700,
                341800,
                350100,
                350300,
                350400,
                350500,
                350600,
                350700,
                350800,
                350900,
                360000,
                370000,
                410000,
                420200,
                420300,
                420500,
                420600,
                420700,
                420800,
                420900,
                421000,
                421100,
                421200,
                421300,
                422800,
                429078,
                429093,
                429094,
                429095,
                430000,
                440200,
                440400,
                440700,
                440800,
                440900,
                441200,
                441300,
                441400,
                441500,
                441600,
                441700,
                441800,
                442099,
                445100,
                445200,
                445300,
                450000,
                460000,
                510300,
                510400,
                510500,
                510600,
                510700,
                510800,
                510900,
                511000,
                511100,
                511300,
                511400,
                511500,
                511600,
                511700,
                511800,
                511900,
                512000,
                513200,
                513300,
                513400,
                520000,
                530000,
                540000,
                610200,
                610300,
                610400,
                610500,
                610600,
                610700,
                610800,
                610900,
                611000,
                620000,
                630000,
                640000,
                650000,
                710199,
                810000,
                820000
              ]
              ,// 地区编码列表
              stayType: 1 // 停留类型
            },

          }
        },
        {
          name: "psl生米",
          map: {
            region: {
              regionCodeList: [
                130000,
                140000,
                150000,
                210000,
                220000,
                230000,
                320200,
                320300,
                320400,
                320500,
                320600,
                320700,
                320800,
                320900,
                321000,
                321200,
                321300,
                330200,
                330300,
                330400,
                330500,
                330700,
                330800,
                330900,
                331000,
                331100,
                340000,
                350100,
                350300,
                350400,
                350500,
                350600,
                350700,
                350800,
                350900,
                360000,
                370000,
                410000,
                420200,
                420300,
                420500,
                420600,
                420700,
                420800,
                420900,
                421000,
                421100,
                421200,
                421300,
                422800,
                429078,
                429093,
                429094,
                429095,
                430000,
                440200,
                440400,
                440500,
                440600,
                440700,
                440800,
                440900,
                441200,
                441300,
                441400,
                441500,
                441600,
                441700,
                441800,
                442099,
                445100,
                445200,
                445300,
                450000,
                460000,
                510000,
                520000,
                530000,
                540000,
                610200,
                610300,
                610400,
                610500,
                610600,
                610700,
                610800,
                610900,
                611000,
                620000,
                630000,
                640000,
                650000,
                710199,
                810000,
                820000
              ]
              ,// 地区编码列表
              stayType: 1 // 停留类型

            },
          }
        },
      ],


    };
  },
  watch: {  // 新增监听器
    result(newVal) {
      this.time_list = newVal
    }
  },
  computed: {
    result() {
      const bits = new Array(48).fill(0)
      this.timeRanges.forEach(range => {
        const start = this.timeToIndex(range.start)
        const end = this.timeToIndex(range.end)
        for (let i = start; i < end && i < 48; i++) {
          bits[i] = 1
        }
      })
      const resultStr = bits.join('');
      this.time_list = resultStr.repeat(7);
      console.log(this.time_list)
    },

    isLastEndMax() {
      const last = this.timeRanges[this.timeRanges.length - 1]
      return this.timeToIndex(last.end) >= 47
    }
  },

  methods: {

    async placeTypeChange(data) {
      if (!this.formLabelAlign.mediaType) {
        this.$message.warning('请选择投放渠道后重选');
      }
      if (!this.beSelectAdType) {
        this.$message.warning('请选择推广目标后重选');
      }
      console.log(data);
      console.log(this.idsList);
      let time1 = parseInt(new Date().getTime()) + '';
      let nonce = Math.round(Math.random() * 100000000000)
      let data1 = {
        normId: parseInt(data[1]) || 0,
        mediaType: parseInt(this.formLabelAlign.mediaType) || 0,
        adType: parseInt(this.beSelectAdType) || 0,
        displayType: parseInt(data[0]) || 0
      };
      await axios.post('api/openapi/v1/ad/positionList/virtualPositionList?access_token=' + this.idsList[0].token + '&timestamp=' + time1 + '&nonce=' + nonce + '&advertiser_id=' + this.idsList[0].ids + '',
        data1).then(async res => {
          console.log(res);
          this.virtualPositionoptions = res.data.data;
          this.virtualPositionvalue = this.virtualPositionoptions.map(item => item.virtualPositionUuid);
          console.log(this.virtualPositionvalue);
        })
    },
    handleInput() {
      // 根据 mediaType 判断每行最大字符数
      this.maxLength = this.formLabelAlign.mediaType === '1' ? 26 : 15;

      // 将文本域的内容按行分割并过滤掉空行
      this.formLabelAlign3.title = this.titlesString.split('\n').filter(line => line.trim());

      // 检查每一行是否超过字符限制，并保存超出限制的行
      this.linesWithLimitError = this.formLabelAlign3.title
        .map((line, index) => ({
          line: line,
          index: index + 1,
          length: line.length,
        }))
        .filter(item => item.length > this.maxLength) // 过滤掉没有超出限制的行
        .map(item => item.line); // 仅返回超出限制的行文本


      // 如果存在超出字符数的行，更新提示信息
    },
    zshandleInput() {
      // 根据 mediaType 判断每行最大字符数
      this.maxLength = this.formLabelAlign.mediaType === '1' ? 26 : 15;

      // 将文本域的内容按行分割并过滤掉空行
      this.zstitleList = this.zstitlesString.split('\n').filter(line => line.trim());

      // 检查每一行是否超过字符限制，并保存超出限制的行
      this.zslinesWithLimitError = this.zstitleList
        .map((line, index) => ({
          line: line,
          index: index + 1,
          length: line.length,
        }))
        .filter(item => item.length > this.maxLength) // 过滤掉没有超出限制的行
        .map(item => item.line); // 仅返回超出限制的行文本


      // 如果存在超出字符数的行，更新提示信息
    },
    timeToIndex(time) {
      if (time === '24:00') return 48
      const [h, m] = time.split(':').map(Number)
      return h * 2 + (m === 30 ? 1 : 0)
    },

    indexToTime(index) {
      if (index === 48) return '24:00'
      const hours = Math.floor(index / 2)
      const mins = index % 2 === 0 ? '00' : '30'
      return `${String(hours).padStart(2, '0')}:${mins}`
    },

    startOptions(index) {
      const minTime = index === 0
        ? '00:00'
        : this.timeRanges[index - 1].end
      const maxTime = index < this.timeRanges.length - 1
        ? this.timeRanges[index + 1].start
        : '24:00'

      const times = []
      let startIndex = this.timeToIndex(minTime)
      const endIndex = this.timeToIndex(maxTime)

      while (startIndex <= endIndex) {
        times.push(this.indexToTime(startIndex))
        startIndex++
      }

      return {
        start: '00:00',
        end: '24:00',
        step: '00:30',
        selectableRange: times.join(' - ')
      }
    },

    endOptions(index) {
      const startIndex = this.timeToIndex(this.timeRanges[index].start)
      const times = []

      for (let i = startIndex; i <= 48; i++) {
        times.push(this.indexToTime(i))
      }

      return {
        start: '00:00',
        end: '24:00',
        step: '00:30',
        selectableRange: times.join(' - ')
      }
    },

    addRange() {
      const last = this.timeRanges[this.timeRanges.length - 1]
      this.timeRanges.push({
        start: last.end,
        end: '24:00'
      })
    },

    removeRange(index) {
      if (this.timeRanges.length <= 1) return
      this.timeRanges.splice(index, 1)
    },
    /** 获取今日总数 */
    async fetchAdvRecordTodayTotal() {
      try {
        const res = await axios.get("https://control.zjwec.cn/api/creative-counts/today-total");
        if (res.data && res.data.code === "0") {
          this.advRecordTodayTotal = res.data.data.total;
        }
      } catch (e) {
        this.$message.error("获取今日总数失败");
      }
    },
    handleStartChange(index) {
      const current = this.timeRanges[index]
      // 确保结束时间 >= 开始时间
      if (this.timeToIndex(current.start) > this.timeToIndex(current.end)) {
        this.$set(current, 'end', current.start)
      }
      // 更新后续时间段的开始时间
      if (index < this.timeRanges.length - 1) {
        const next = this.timeRanges[index + 1]
        this.$set(next, 'start', current.end)
        // 检查后续时间段是否有效
        if (this.timeToIndex(next.end) < this.timeToIndex(next.start)) {
          this.$set(next, 'end', next.start)
          this.handleEndChange(index + 1)
        }
      }
    },

    handleEndChange(index) {
      const current = this.timeRanges[index]
      // 更新后续时间段的开始时间
      if (index < this.timeRanges.length - 1) {
        const next = this.timeRanges[index + 1]
        this.$set(next, 'start', current.end)
        // 检查后续时间段是否有效
        if (this.timeToIndex(next.end) < this.timeToIndex(next.start)) {
          this.$set(next, 'end', next.start)
          this.handleEndChange(index + 1)
        }
      }
      // 确保开始时间 <= 结束时间
      if (this.timeToIndex(current.start) > this.timeToIndex(current.end)) {
        this.$set(current, 'start', current.end)
      }
    },
    async fetchHdCookieData() {
      const pageNum = 1;
      const uid = 1;
      const role = 1;
      const pageSize = 10;
      const name = ''; // 根据需要修改此参数
      const url = `https://control.zjwec.cn/api/hdcookie/page?pageNum=${pageNum}&uid=${uid}&role=${role}&pageSize=${pageSize}&name=${encodeURIComponent(name)}`;
      try {
        const response = await axios.get(url);
        console.log('数据获取成功:', response.data);
        this.zjcookie = response.data.data.records[0].hdcookie

        // 这里可以处理返回的数据，例如更新到状态管理或组件
      } catch (error) {
        console.error('错误:', error);
      }
    },
    sckhb() {
      const params = new URLSearchParams();
      let idsString = this.idsList.map(item => item.ids).join(',');
      let cookieid = this.zjcookie + ';b_marketing_subid='



        + this.selectedsucaiku.uid

      params.append('targetUserIds', idsString);
      params.append('cookie', cookieid)
      // 使用 axios 发送 GET 请求，将参数以查询字符串的形式附加到 URL 上
      axios.get('https://control.zjwec.cn/api/kaihu/sendShareRequest', {
        params: params,
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded'
        }
      })
        .then(res => {
          console.log(res.data); // 处理返回的数据
        })
        .catch(error => {
          console.error('Error:', error); // 处理错误
        });
    },

    clearShangPing() {
      this.categoryName = ''
      this.beSelectCategory = null
      this.categoryList = []

    },
    async GetPlanId(id, token) {
      const timestamp = parseInt(new Date().getTime()) + '';
      const nonce = Math.round(Math.random() * 100000000000);

      await axios.post(`api/openapi/v1/ad/campaign/pageInfoByLastId?access_token=${token}&timestamp=${timestamp}&nonce=${nonce}&advertiser_id=${id}`,
        {
          "lastId": 0,
          "deleted": 0,
          "pageSize": 100
        }
      ).then(
        res => {
          this.ePlanId = (res.data && res.data.data && res.data.data.lastId) ? res.data.data.lastId : '';
        }
      )
    },

    async GetGroupPrice(id, token) {
      let allData = []; // 存储所有 data 数据
      let currentLastId = 0; // 初始 lastId
      let lastValidLastId = null; // 记录最后一次有效的 lastId

      while (currentLastId !== undefined && currentLastId !== null) {
        const timestamp = Date.now().toString();
        const nonce = Math.floor(Math.random() * 100000000000);

        try {
          const response = await axios.post(
            `api/openapi/v1/ad/group/pageInfoByLastId?access_token=${token}&timestamp=${timestamp}&nonce=${nonce}&advertiser_id=${id}`,
            {
              lastId: currentLastId,
              deleted: 0,
              pageSize: 100
            }
          );

          const responseData = response.data && response.data.data; // 兼容 ES5 的写法
          if (responseData) {
            // 拼接数据
            if (Array.isArray(responseData.data)) {
              allData = allData.concat(responseData.data);
            }

            // 更新 lastId
            if (responseData.lastId !== undefined && responseData.lastId !== null) {
              lastValidLastId = responseData.lastId;
              currentLastId = responseData.lastId;
            } else {
              currentLastId = null; // 终止循环
            }
          } else {
            currentLastId = null; // 数据异常终止
          }
        } catch (error) {
          console.error("请求失败:", error);
          break;
        }
      }

      console.log("最后获取到的 lastId:", lastValidLastId);

      // 查找目标对象
      const targetObject = allData.find(item => item.id === lastValidLastId);
      console.log("匹配对象:", targetObject);

      // 安全处理 undefined 和属性访问
      if (targetObject && typeof targetObject.ocpxPrice !== 'undefined') {
        this.oldGroupPrice = targetObject.ocpxPrice;
      } else {
        // 备选方案：可以设置默认值/保持原值/抛出警告
        console.warn('未找到匹配对象或 ocpxPrice 不存在');
        this.oldGroupPrice = new Decimal(this.formLabelAlign1.ocpxPrice).mul(100000).toNumber(); // 或保留原值：delete this.oldGroupPrice;
      }

    },

    handleCategoryChange() {
      // 根据选中的分类名称查找完整的对象
      this.selectedCategory = this.categories.find(category => category.categoryName === this.selectedCategoryName);
    },
    handlesucaiku() {
      // 根据选中的分类名称查找完整的对象
      this.selectedsucaiku = this.sucaikus.find(sucaiku => sucaiku.uname === this.sucainame);

    },
    handleQuery() {
      if (this.selectedCategoryName) {
        // 发起请求，传入选中的分类名称
        this.queryCategoryData();
      } else {
        this.$message.warning('请选择一个分类');
      }
    },
    // 监听选择框值变化的方法
    CategorySelectHandle(value) {
      console.log('选中的商品对象:', value);
      // 在此执行任何额外的操作，比如发送请求、处理逻辑等
      // this.$message.info(`你选择了: ${newValue.name}`);
      this.beSelectCategory = this.categoryList.find(item => item.id === value);
      console.log('选中的商品对象是' + JSON.stringify(this.beSelectCategory))
    },
    queryCategoryData() {
      // 发送请求，传入商品库ID
      const timestamp = parseInt(new Date().getTime()) + '';
      const nonce = Math.round(Math.random() * 100000000000);

      console.log(this.selectedCategory)
      this.$axios.post(`api/openapi/v1/ad/product/info/page?access_token=${this.selectedCategory.categoryUtoken}&timestamp=${timestamp}&nonce=${nonce}&advertiser_id=${this.selectedCategory.categoryUid}`, {
        productLibraryId: this.selectedCategory.categoryId,
        pageSize: 1000
      })
        .then(response => {
          this.categoryList = response.data.data.list

          console.log('查询结果:', response.data.data.list);
          // 这里可以处理请求成功后的逻辑
          this.$message.success('查询成功');
        })
        .catch(error => {
          console.error('请求失败:', error);
          this.$message.error('查询失败');
        });
    },
    // 添加新的输入框
    addProduct() {
      this.formLabelAlign3.productNames.push('');
    },
    // 删除指定索引的输入框
    removeProduct(index) {
      if (this.formLabelAlign3.productNames.length > 1) {
        this.formLabelAlign3.productNames.splice(index, 1);
      }
    },
    diYuHandleSelectionChange() {
      this.beSelectMap = this.mapArray.find(item => item.name === this.beSelectDiYu);

      console.log("选中的定向是：" + JSON.stringify(this.beSelectMap))
    },
    shuffle(arr) {
      var l = arr.length
      var index, temp
      while (l > 0) {
        index = Math.floor(Math.random() * l)
        temp = arr[l - 1]
        arr[l - 1] = arr[index]
        arr[index] = temp
        l--
      }
      return arr
    },

    // 获取资质id
    // 发送请求获取数据
    async GetZZData(uid, token) {
      const timestamp = parseInt(new Date().getTime()) + '';
      const nonce = Math.round(Math.random() * 100000000000);

      const url = `api/openapi/v1/advertise/qualification/list?access_token=${token}&timestamp=${timestamp}&nonce=${nonce}&advertiser_id=${uid}`;
      const response = await axios.post(url, {});

      if (response.data.code === 0 && response.data.data) {

        console.log("账户" + uid + "取到的所有行业是" + response.data.data)
        this.zzIdList = response.data.data
      }
      return [];
    },
    openAdvRecordDetailDialog() {
      this.advRecordDetailDialogVisible = true;
      this.fetchAdvRecordDetailData();
    },
    async fetchAdvRecordDetailData() {
      try {
        let allData = [];
        let totalCount = 0;

        // 遍历每个素材库，逐个请求
        for (let acc of this.sucaikus) {
          const res = await axios.get("https://control.zjwec.cn/api/creative-counts/page", {
            params: {
              date: this.advRecordQueryDate,
              accountNameLike: acc.uname, // 传 uname
              pageNo: 1,
              pageSize: 1, // 每个库只要 1 条汇总结果
            },
          });

          if (res.data && res.data.code === '0') {
            const pageData = res.data.data;
            if (pageData.records && pageData.records.length > 0) {
              const record = pageData.records[0];
              allData.push(record);
              totalCount += record.accountCount;
            }
          }
        }

        // 更新前端显示
        this.advRecordDetailList = allData;
        this.advRecordDetailTotal = totalCount;

      } catch (e) {
        this.$message.error("获取详情数据失败");
      }
    },

    getDefaultStatDate() {
      const now = dayjs();
      // 如果当前时间 >= 18:00，算作次日
      if (now.hour() >= 18) {
        return now.add(1, "day").format("YYYY-MM-DD");
      }
      return now.format("YYYY-MM-DD");
    },
    clearfile() {

      this.fileList = []
      this.VideofileList = []
    },
    zsclearfile() {

      this.zsfileList = []
      this.zsVideofileList = []
    },
    async GetPlan() {
      this.countdialogVisible = false
      this.sckhb()
      this.fileCode = []
      this.videofileCode = []
      this.zsfileCode = []
      this.zsvideofileCode = []
      // 上传素材
      const placeType = this.formLabelAlign3.placeType[1];
      const needsVideo = ['61', '122', '75', '242'].includes(placeType);

      await this.upload();
      await this.zsupload();
      if (needsVideo) {

        await this.uploadVideo();
        await this.zsuploadVideo();
      }

      if (!this.customListpc) {
        this.flag2 = false;
      } else {
        this.customListrqbpc = this.customListpc
          .split(',')
          .map(t => parseInt(t, 10));
        console.log(this.customListrqbpc);
        this.flag2 = true;
      }

      if (this.customList2 === '') {
        this.flag1 = false
      } else {
        this.customListrqb = []
        let temp = []
        temp = this.customList2.split(",");
        for (let t1 in temp) {
          this.customListrqb[t1] = parseInt(temp[t1])
        }
        console.log(this.customListrqb)
        this.flag1 = true
      }
      this.sexList = [];
      if (this.sex === "女") {
        this.sexList[0] = 20
      } else if (this.sex === "男") {
        this.sexList[0] = 19
      }
      this.ageIdList = []
      for (let key in this.age) {
        this.ageIdList[key] = this.ages[this.age[key]].id
      }
      console.log(this.ageIdList)
      if (this.formLabelAlign3.placeType[1] === '61' || this.formLabelAlign3.placeType[1] === '122') {
        let t = 0;
        for (let key in this.idsList) {
          if (this.daluan === true) {
            this.formLabelAlign3.title = this.shuffle(this.formLabelAlign3.title)
          }
          let parms = {
            name: this.idsList[key].planName,
            mediaType: this.formLabelAlign.mediaType,
            dailyBudget: this.formLabelAlign.dailyBudget,
            id: key,
            token: this.idsList[key].token,
            ids: this.idsList[key].ids
          }
          let parms1 = {
            name: this.idsList[key].planName,
            mediaType: this.formLabelAlign.mediaType,
            id: key,
            token: this.idsList[key].token,
            ids: this.idsList[key].ids
          }
          await this.GetZZData(this.idsList[key].ids, this.idsList[key].token)
          await this.GetPlanId(this.idsList[key].ids, this.idsList[key].token)
          await this.GetGroupPrice(this.idsList[key].ids, this.idsList[key].token)
          if (this.ePlanId !== '' && this.newplanflag === true) {
            let groundData = {
              token: this.idsList[key].token,
              ids: this.idsList[key].ids,
              campaignId: this.ePlanId,
              webSiteUrl: this.idsList[key].url,
              id: key,
              startDate: this.startDate,
              ocpxPrice: this.isoldgroupprice ? this.oldGroupPrice : new Decimal(this.formLabelAlign1.ocpxPrice).mul(100000).toNumber(),
              name: this.idsList[key].planName,
              cvType: this.formLabelAlign1.cvType,
              builtInRpkDeepLink: this.idsList[key].builtInRpkDeepLink
            }
            await this.stopPlan(groundData)
            await this.ground(groundData)
          }
          else {
            await this.plan(parms)
            let groundData = {
              token: this.idsList[key].token,
              ids: this.idsList[key].ids,
              campaignId: this.idsList[key].planId,
              webSiteUrl: this.idsList[key].url,
              id: key,
              startDate: this.startDate,
              ocpxPrice: this.isoldgroupprice ? this.oldGroupPrice : new Decimal(this.formLabelAlign1.ocpxPrice).mul(100000).toNumber(),
              name: this.idsList[key].planName,
              cvType: this.formLabelAlign1.cvType,
              builtInRpkDeepLink: this.idsList[key].builtInRpkDeepLink
            }
            await this.stopPlan(groundData)
            await this.ground(groundData)

          }
          let data = {
            token: this.idsList[key].token,
            ids: this.idsList[key].ids,
            groupId: this.idsList[key].groundId,
          }
          await this.PostGroupTime(data)
          await this.txupload();




          // 获取素材配置参数
          const normalCount = this.countformData.normalCount;
          const reviewCount = this.countformData.reviewCount;

          // 生成普通素材队列（图片+视频+标题）
          const normalMaterials = Array.from({ length: normalCount }, (_, i) => {
            const pos = (this.currentNormalIndex + i) % this.fileCode.length;
            return {
              img: this.fileCode[pos],
              video: this.videofileCode[pos],
              title: this.formLabelAlign3.title[pos],
              type: 'normal'
            };
          });

          // 生成撞审素材队列（图片+视频+标题）
          const reviewMaterials = Array.from({ length: reviewCount }, (_, i) => {
            const pos = (this.currentReviewIndex + i) % this.zsfileCode.length;
            return {
              img: this.zsfileCode[pos],
              video: this.zsvideofileCode[pos],
              title: this.zstitleList[pos],
              type: 'review'
            };
          });

          // 合并并随机排序（实现撞审素材随机穿插）
          const combinedMaterials = [...normalMaterials, ...reviewMaterials];
          for (let i = combinedMaterials.length - 1; i > 0; i--) {
            const j = Math.floor(Math.random() * (i + 1));
            [combinedMaterials[i], combinedMaterials[j]] = [combinedMaterials[j], combinedMaterials[i]];
          }

          // 构建创意列表
          this.creativeList = combinedMaterials.map(material => {
            const arr = {
              avatarCode: this.txfileCode[0],
              imgsCode: material.img,
              videoCode: material.video,
              title: material.title,
              placeType: this.formLabelAlign3.placeType[0],
              productName: this.formLabelAlign3.productNames[
                Math.floor(Math.random() * this.formLabelAlign3.productNames.length)
              ],
              materialNormId: this.formLabelAlign3.placeType[1]
            };

            // 根据媒体类型处理特殊字段
            if (this.formLabelAlign.mediaType === '2') {
              arr.appName = this.formLabelAlign3.productNames[
                Math.floor(Math.random() * this.formLabelAlign3.productNames.length)
              ];
              arr.subTitle = material.title;
            }
            arr.virtualPositionId = this.virtualPositionvalue.join(',');

            return arr;
          });

          // 更新轮转索引（考虑数组循环）
          this.currentNormalIndex = (this.currentNormalIndex + normalCount) % this.fileCode.length;
          this.currentReviewIndex = (this.currentReviewIndex + reviewCount) % this.zsfileCode.length;

          // 提交请求
          const payload = {
            token: this.idsList[key].token,
            ids: this.idsList[key].ids,
            creativeList: this.creativeList,
            groupId: this.idsList[key].groundId,
            name: this.idsList[key].planName,
            clickMonitorUrl: this.idsList[key].xiaoshuourl,
            viewMonitorUrl: this.idsList[key].baoguangurl,
            adcreativedeeplink: this.idsList[key].adcreativedeeplink,
            username: this.idsList[key].username,
            twoname: this.idsList[key].twoname,
            id: key
          };
          await this.guanggao(payload);
          let num = 100 / this.idsList.length;
          this.percentages = num * (Number(key) + 1);
        }


        if (this.percentages === 100) {
          this.$notify({
            title: 'success',
            message: '批量搭建工程全部完成！',
            type: 'success'
          });
        }
      }
      else if (this.formLabelAlign3.placeType[1] === '75' || this.formLabelAlign3.placeType[1] === '242') {

        let t = 0;

        for (let key in this.idsList) {
          if (this.daluan === true) {
            this.formLabelAlign3.title = this.shuffle(this.formLabelAlign3.title)
          }

          let parms = {
            name: this.idsList[key].planName,
            mediaType: this.formLabelAlign.mediaType,
            dailyBudget: this.formLabelAlign.dailyBudget,
            id: key,
            token: this.idsList[key].token,
            ids: this.idsList[key].ids
          }
          let parms1 = {
            name: this.idsList[key].planName,
            mediaType: this.formLabelAlign.mediaType,
            id: key,
            token: this.idsList[key].token,
            ids: this.idsList[key].ids
          }

          // if (this.stopAll == true){
          //   this.stopAll = false
          //   return false
          // }
          await this.GetZZData(this.idsList[key].ids, this.idsList[key].token)
          await this.GetPlanId(this.idsList[key].ids, this.idsList[key].token)
          await this.GetGroupPrice(this.idsList[key].ids, this.idsList[key].token)

          if (this.ePlanId !== '' && this.newplanflag === true) {
            let groundData = {
              token: this.idsList[key].token,
              ids: this.idsList[key].ids,
              campaignId: this.ePlanId,
              webSiteUrl: this.idsList[key].url,
              id: key,
              startDate: this.startDate,
              ocpxPrice: this.isoldgroupprice ? this.oldGroupPrice : new Decimal(this.formLabelAlign1.ocpxPrice).mul(100000).toNumber(),
              name: this.idsList[key].planName,
              cvType: this.formLabelAlign1.cvType,
              builtInRpkDeepLink: this.idsList[key].builtInRpkDeepLink
            }
            await this.stopPlan(groundData)
            await this.ground(groundData)

          }
          else {
            await this.plan(parms)
            let groundData = {
              token: this.idsList[key].token,
              ids: this.idsList[key].ids,
              campaignId: this.idsList[key].planId,
              webSiteUrl: this.idsList[key].url,
              id: key,
              startDate: this.startDate,
              ocpxPrice: this.isoldgroupprice ? this.oldGroupPrice : new Decimal(this.formLabelAlign1.ocpxPrice).mul(100000).toNumber(),
              name: this.idsList[key].planName,
              cvType: this.formLabelAlign1.cvType,
              builtInRpkDeepLink: this.idsList[key].builtInRpkDeepLink
            }
            await this.stopPlan(groundData)
            await this.ground(groundData)

          }
          let data = {
            token: this.idsList[key].token,
            ids: this.idsList[key].ids,
            groupId: this.idsList[key].groundId,
          }
          await this.PostGroupTime(data)
          await this.txupload()
          const normalCount = this.countformData.normalCount;
          const reviewCount = this.countformData.reviewCount;

          // 生成普通素材队列（图片+视频+标题）
          const normalMaterials = Array.from({ length: normalCount }, (_, i) => {
            const pos = (this.currentNormalIndex + i) % this.fileCode.length;
            return {
              img: this.fileCode[pos],
              video: this.videofileCode[pos],
              title: this.formLabelAlign3.title[pos],
              type: 'normal'
            };
          });

          // 生成撞审素材队列（图片+视频+标题）
          const reviewMaterials = Array.from({ length: reviewCount }, (_, i) => {
            const pos = (this.currentReviewIndex + i) % this.zsfileCode.length;
            return {
              img: this.zsfileCode[pos],
              video: this.zsvideofileCode[pos],
              title: this.zstitleList[pos],
              type: 'review'
            };
          });

          // 合并并随机排序（实现撞审素材随机穿插）
          const combinedMaterials = [...normalMaterials, ...reviewMaterials];
          for (let i = combinedMaterials.length - 1; i > 0; i--) {
            const j = Math.floor(Math.random() * (i + 1));
            [combinedMaterials[i], combinedMaterials[j]] = [combinedMaterials[j], combinedMaterials[i]];
          }

          // 构建创意列表
          this.creativeList = combinedMaterials.map(material => {
            const arr = {
              avatarCode: this.txfileCode[0],
              imgsCode: material.img,
              videoCode: material.video,
              title: material.title,
              placeType: this.formLabelAlign3.placeType[0],
              productName: this.formLabelAlign3.productNames[
                Math.floor(Math.random() * this.formLabelAlign3.productNames.length)
              ],
              materialNormId: this.formLabelAlign3.placeType[1]
            };

            // 根据媒体类型处理特殊字段
            if (this.formLabelAlign.mediaType === '2') {
              arr.appName = this.formLabelAlign3.productNames[
                Math.floor(Math.random() * this.formLabelAlign3.productNames.length)
              ];
              arr.subTitle = material.title;
            }
            arr.virtualPositionId = this.virtualPositionvalue.join(',');

            return arr;
          });

          // 更新轮转索引（考虑数组循环）
          this.currentNormalIndex = (this.currentNormalIndex + normalCount) % this.fileCode.length;
          this.currentReviewIndex = (this.currentReviewIndex + reviewCount) % this.zsfileCode.length;

          // 提交请求
          const payload = {
            token: this.idsList[key].token,
            ids: this.idsList[key].ids,
            creativeList: this.creativeList,
            groupId: this.idsList[key].groundId,
            name: this.idsList[key].planName,
            clickMonitorUrl: this.idsList[key].xiaoshuourl,
            viewMonitorUrl: this.idsList[key].baoguangurl,
            adcreativedeeplink: this.idsList[key].adcreativedeeplink,
            username: this.idsList[key].username,
            twoname: this.idsList[key].twoname,
            id: key
          };
          await this.guanggao(payload);
          let num = 100 / this.idsList.length;
          this.percentages = num * (Number(key) + 1);
        }

        if (this.percentages === 100) {
          this.$notify({
            title: 'success',
            message: '批量搭建工程全部完成！',
            type: 'success'
          });
        }
      }
      else {
        let t = 0;
        for (let key in this.idsList) {
          if (this.daluan === true) {
            this.formLabelAlign3.title = this.shuffle(this.formLabelAlign3.title)
          }

          let parms = {
            name: this.idsList[key].planName,
            mediaType: this.formLabelAlign.mediaType,
            dailyBudget: this.formLabelAlign.dailyBudget,
            id: key,
            token: this.idsList[key].token,
            ids: this.idsList[key].ids
          }


          // if (this.stopAll == true){
          //   this.stopAll = false
          //   return false
          // }
          await this.GetZZData(this.idsList[key].ids, this.idsList[key].token)
          await this.GetPlanId(this.idsList[key].ids, this.idsList[key].token)
          await this.GetGroupPrice(this.idsList[key].ids, this.idsList[key].token)
          await this.txupload();
          if (this.ePlanId !== '' && this.newplanflag === true) {

            let groundData = {
              token: this.idsList[key].token,
              ids: this.idsList[key].ids,
              campaignId: this.ePlanId,
              webSiteUrl: this.idsList[key].url,
              id: key,
              startDate: this.startDate,
              ocpxPrice: this.isoldgroupprice ? this.oldGroupPrice : new Decimal(this.formLabelAlign1.ocpxPrice).mul(100000).toNumber(),
              name: this.idsList[key].planName,
              cvType: this.formLabelAlign1.cvType,
              builtInRpkDeepLink: this.idsList[key].builtInRpkDeepLink
            }
            await this.stopPlan(groundData)
            await this.ground(groundData)
            let data = {
              token: this.idsList[key].token,
              ids: this.idsList[key].ids,
              groupId: this.idsList[key].groundId,
            }
            console.log(this.idsList)
            await this.PostGroupTime(data)


          }

          else {
            await this.plan(parms)
            let groundData = {
              token: this.idsList[key].token,
              ids: this.idsList[key].ids,
              campaignId: this.idsList[key].planId,
              webSiteUrl: this.idsList[key].url,
              id: key,
              startDate: this.startDate,
              ocpxPrice: this.isoldgroupprice ? this.oldGroupPrice : new Decimal(this.formLabelAlign1.ocpxPrice).mul(100000).toNumber(),
              name: this.idsList[key].planName,
              cvType: this.formLabelAlign1.cvType,
              builtInRpkDeepLink: this.idsList[key].builtInRpkDeepLink
            }
            await this.stopPlan(groundData)
            await this.ground(groundData)
            let data = {
              token: this.idsList[key].token,
              ids: this.idsList[key].ids,
              groupId: this.idsList[key].groundId,
            }
            console.log(this.idsList)
            await this.PostGroupTime(data)
          }

          const normalCount = this.countformData.normalCount;
          const reviewCount = this.countformData.reviewCount;

          // 生成普通素材队列（图片+视频+标题）
          const normalMaterials = Array.from({ length: normalCount }, (_, i) => {
            const pos = (this.currentNormalIndex + i) % this.fileCode.length;
            return {
              img: this.fileCode[pos],
              video: this.videofileCode[pos],
              title: this.formLabelAlign3.title[pos],
              type: 'normal'
            };
          });

          // 生成撞审素材队列（图片+视频+标题）
          const reviewMaterials = Array.from({ length: reviewCount }, (_, i) => {
            const pos = (this.currentReviewIndex + i) % this.zsfileCode.length;
            return {
              img: this.zsfileCode[pos],
              video: this.zsvideofileCode[pos],
              title: this.zstitleList[pos],
              type: 'review'
            };
          });

          // 合并并随机排序（实现撞审素材随机穿插）
          const combinedMaterials = [...normalMaterials, ...reviewMaterials];
          for (let i = combinedMaterials.length - 1; i > 0; i--) {
            const j = Math.floor(Math.random() * (i + 1));
            [combinedMaterials[i], combinedMaterials[j]] = [combinedMaterials[j], combinedMaterials[i]];
          }

          // 构建创意列表
          this.creativeList = combinedMaterials.map(material => {
            const arr = {
              avatarCode: this.txfileCode[0],
              imgsCode: material.img,
              videoCode: material.video,
              title: material.title,
              placeType: this.formLabelAlign3.placeType[0],
              productName: this.formLabelAlign3.productNames[
                Math.floor(Math.random() * this.formLabelAlign3.productNames.length)
              ],
              materialNormId: this.formLabelAlign3.placeType[1]
            };

            // 根据媒体类型处理特殊字段
            if (this.formLabelAlign.mediaType === '2') {
              arr.appName = this.formLabelAlign3.productNames[
                Math.floor(Math.random() * this.formLabelAlign3.productNames.length)
              ];
              arr.subTitle = material.title;
            }
            // if (this.formLabelAlign.mediaType === '1') {
            //   arr.virtualPositionId = "1,2,13";
            // } else {
            //   const placeTypeSecond = this.formLabelAlign3.placeType[1];
            //   const typeIdMap = { '35': 9, '85': 9, '39': 11 };
            //   // 用逻辑或 || 替代空值合并运算符 ??
            //   arr.virtualPositionId = typeIdMap[placeTypeSecond] || 12; // 当值不存在时 fallback 到 12
            // }
            arr.virtualPositionId = this.virtualPositionvalue.join(',');

            return arr;
          });

          // 更新轮转索引（考虑数组循环）
          this.currentNormalIndex = (this.currentNormalIndex + normalCount) % this.fileCode.length;
          this.currentReviewIndex = (this.currentReviewIndex + reviewCount) % this.zsfileCode.length;

          // 提交请求
          const payload = {
            token: this.idsList[key].token,
            ids: this.idsList[key].ids,
            creativeList: this.creativeList,
            groupId: this.idsList[key].groundId,
            name: this.idsList[key].planName,
            clickMonitorUrl: this.idsList[key].xiaoshuourl,
            viewMonitorUrl: this.idsList[key].baoguangurl,
            adcreativedeeplink: this.idsList[key].adcreativedeeplink,
            username: this.idsList[key].username,
            twoname: this.idsList[key].twoname,
            id: key
          };
          await this.guanggao(payload);

          let num = 100 / this.idsList.length;
          this.percentages = num * (Number(key) + 1);

        }

        if (this.percentages === 100) {
          this.$notify({
            title: 'success',
            message: '批量搭建工程全部完成！',
            type: 'success'
          });
        }


      }



    },
    async findIds() {
      this.idsList = [];
      const accountList = this.accounts.split('\n').filter(line => line.trim());

      try {
        // 并行发送所有请求
        const promises = accountList.map(account =>
          axios.post('https://test.nbweiou.cn/api/getByIdsName', { "idsname": account })
        );

        // 等待所有请求完成
        const responses = await Promise.all(promises);

        // 提取结果（res.data）并合并到 idsList
        this.idsList = responses.map(res => res.data[0]);
      } catch (error) {
        console.error('部分请求失败:', error);
      }
    }

    // async findIds(){
    //
    //   this.idsList=[],
    //     await axios.post('https://test.nbweiou.cn/api/get_ids',{
    //       'username':this.username,
    //       'twoname':this.towName
    //     }).then(
    //       async res=>{
    //         this.idsList=res.data;
    //       },
    //     )
    // }
    ,
    ro() {
      this.formLabelAlign3.title = []

    },
    //刷新信息
    async GetRo() {

      let time1 = parseInt(new Date().getTime()) + '';
      console.log(time1)

      await axios.post('https://test.nbweiou.cn/api/get_vivo_user', {
        'username': this.username
      }).then(
        res => {
          this.two = res.data
          // for (let key in res.data){
          //   this.twoName[key]=res.data[key].twoname
          //   this.towToken[key]=res.data[key].token
          // }
        }
      )
    },
    //停止计划api
    async stopPlan(parms) {
      let flag1 = 0;
      if (this.flag === false) {
        flag1 = 1
      } else {
        flag1 = 0;
      }

      let time1 = parseInt(new Date().getTime()) + '';
      let nonce = Math.round(Math.random() * 100000000000)
      await axios.post('api/openapi/v1/ad/campaign/pause/toggle?access_token=' + parms.token + '&timestamp=' + time1 + '&nonce=' + nonce + '&advertiser_id=' + parms.ids + '',
        {
          "ids": parms.campaignId,
          "startAndStop": flag1
        }).then(res => {

          //推广计划id id
        })
    },
    // 搭建计划api
    async plan(parms) {
      let time1 = parseInt(new Date().getTime()) + '';
      let nonce = Math.round(Math.random() * 100000000000)
      let adtypes = 1;
      let names = '';
      if (this.idsList[parms.id].url.substr(0, 2) === "ht") {
        adtypes = this.beSelectAdType
        names = parms.name + '_' + time1 + '_' + 'https_' + this.formLabelAlign.name;

      } else if (this.idsList[parms.id].url.substr(0, 2) === "ha") {
        adtypes = this.beSelectAdType
        names = parms.name + '_' + time1 + '_' + 'hap_' + this.formLabelAlign.name;

      }

      if (parms.dailyBudget === '') {
        parms.dailyBudget = -1
      } else {
        parms.dailyBudget = parms.dailyBudget * 100000
      }

      await axios.post('api/openapi/v1/ad/campaign/add?access_token=' + parms.token + '&timestamp=' + time1 + '&nonce=' + nonce + '&advertiser_id=' + parms.ids + '',

        {
          name: names,
          adType: adtypes,
          mediaType: parms.mediaType,
          dailyBudget: parms.dailyBudget,
          optimizeFlag: 0,
          campaignType: 0,
        }).then(res => {
          if (res.data.code === 70111) {
            this.$notify({
              title: '创建失败',
              message: res.data.message,
              type: 'error'
            });
          }
          this.idsList[parms.id].planId = res.data.data.id
          console.log(res.data);
          //推广计划id id
        })

    },
    // 搭建广告组api
    async ground(parms) {

      let price = 0;
      // let price1=30000;
      if (this.formLabelAlign.mediaType === '1') {
        price = 999000
      } else {
        price = 10000
      }
      let map = {};
      if (this.flag1 === true) {
        map["customList"] = this.customListrqb;

      }
      if (this.flag2 === true) {
        map["excludeCustomList"] = this.customListrqbpc;

      }

      // this.erjihangye[0] this.erjihangye[1]
      // this.zzIdList中的子对象industry1和 industry2值
      // 配对后根据adType的值去：快应用选英文的产品名 否则就选网址
      // this.beSelectAdType 被选中的广告类型
      this.zjerji = this.erjihangye

      if (this.zjerji[0] && typeof this.zjerji[0] === 'string') {
        this.zjerji[0] = this.zjerji[0].replace(/["']/g, ''); // 去除双引号或单引号
      }

      if (this.zjerji[1] && typeof this.zjerji[1] === 'string') {
        this.zjerji[1] = this.zjerji[1].replace(/["']/g, ''); // 去除双引号或单引号
      }
      console.log(this.zzIdList)
      console.log(this.beSelectAdType)
      console.log(this.zjerji)
      // 1. 找到符合条件的对象
      let targetObject = this.zzIdList.find(obj => obj.industry1 === Number(this.zjerji[0]) && obj.industry2 === Number(this.zjerji[1]));

      // 2. 如果找到了目标对象
      if (targetObject) {
        let advertiseQualificationList = targetObject.advertiseQualificationList;

        // 3. 根据beSelectAdType的值判断
        this.advertiseQualificationId = advertiseQualificationList.filter(item => {
          console.log(item)
          if (this.beSelectAdType === 8) {
            // 当 beSelectAdType 为 8 时，检查 productName 是否包含字母、数字和点号
            // return /^[A-Za-z0-9.]+$/.test(item.productName);
            return /^com/.test(item.productName);
          } else if (this.beSelectAdType == 11) {
            // 当 beSelectAdType 为 11 时
            return /小程序/.test(item.productDescription);
          } else {

            // 当 beSelectAdType 不为 8 时，检查 productName 是否不完全是字母
            return !/^com/.test(item.productName);
          }

        }).map(item => item.advertiseQualificationId); // 获取advertiseQualificationId

        console.log(this.advertiseQualificationId); // 输出结果
      } else {
        console.log("没有找到符合条件的对象");
      }


      let region = {
        'regionCodeList': this.beSelectMap.map.region.regionCodeList,
        'stayType': 1
      }
      map["sexList"] = this.sexList;
      map["region"] = region;
      // map["customList"]=this.customList;
      map["ageList"] = this.ageIdList;
      if (this.selectedPrices.length !== 9) {
        map["phonePriceSet"] = this.selectedPrices;
      }

      if (this.selectedVersions.length !== 11) {
        map["androidVersionSet"] = this.selectedVersions;
      }

      let time1 = parseInt(new Date().getTime()) + '';
      let nonce = Math.round(Math.random() * 100000000000)
      if (this.idsList[parms.id].url.substr(0, 2) === "ht") {

        // 判断this.beSelectCategory是否为空数组来决定是否添加属性
        let data = {
          // wechatFollow:1,
          audienceInfo: map,

          campaignId: parms.campaignId,
          webSiteUrl: parms.webSiteUrl,
          startDate: this.getNowFormatDate(),
          endDate: '2038-01-19',
          h5Type: 2,
          scheduleTime: '111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111',
          chargeType: 3,
          price: price,
          cvType: this.formLabelAlign1.cvType,
          ocpxPrice: parms.ocpxPrice,
          name: parms.name + '_' + time1 + '_' + this.formLabelAlign.name,
          dailyBudget: -1,
          spentType: 1,
          //channelId:parms.channelId,
          biddingStrategy: 0,

        }

        if (this.isguanz) {
          data.wechatFollow = 1
        } else {
          data.wechatFollow = 0
        }
        if (this.beSelectAdType != 11) {
          data = {
            ...data, builtInRpkDeepLink: parms.builtInRpkDeepLink,
          }
        }
        if (this.beSelectAdType == 11) {
          data = {
            ...data, appletPath: this.idsList[parms.id].adcreativedeeplink,
            appletOriginId: this.idsList[parms.id].builtInRpkDeepLink
          }
        }
        if (this.advertiseQualificationId === '' || this.advertiseQualificationId === undefined) {
          data.industry1 = this.zjerji[0]
          data.industry2 = this.zjerji[1]
        } else {
          data.advertiseQualificationId = this.advertiseQualificationId[0]
        }
        // 如果 this.beSelectCategory 不是空数组，添加 categoryId 属性
        if (this.beSelectCategory && Object.keys(this.beSelectCategory).length > 0) {
          data.productSDpa = {
            productId: this.beSelectCategory.id,
            productName: this.beSelectCategory.name
          }
          data.dpaGoodsConfig = {
            cpId: this.beSelectCategory.productLibraryId,
            categories: [
              {
                categoryId: this.beSelectCategory.thirdCategoryId,
                categoryLevel: 3
              }
            ]
          }
          // 将 beSelectCategory 作为 categoryId 添加
        }
        await axios.post('api/openapi/v1/ad/group/add?access_token=' + parms.token + '&timestamp=' + time1 + '&nonce=' + nonce + '&advertiser_id=' + parms.ids,
          data).then(res => {
            if (res.data.code === 70111) {
              this.$notify({
                title: '创建失败',
                message: res.data.message,
                type: 'error'
              });
            }
            console.log(res);
            this.idsList[parms.id].groundId = res.data.data
            //广告组ID

          })
      }
      else if (this.idsList[parms.id].url.substr(0, 2) === "ha") {
        let data = {
          audienceInfo: map,
          // industry1:2100023,
          // industry2:2220187,
          // advertiseQualificationId: this.advertiseQualificationId[0],
          campaignId: parms.campaignId,
          rpkDeepLink: parms.webSiteUrl,
          startDate: this.getNowFormatDate(),
          endDate: '2038-01-19',
          scheduleTime: '111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111',
          chargeType: 3,
          price: price,

          cvType: this.formLabelAlign1.cvType,
          ocpxPrice: parms.ocpxPrice,
          name: parms.name + '_' + time1 + '_' + this.formLabelAlign.name,
          dailyBudget: -1,
          spentType: 1,
          //channelId:parms.channelId,
          biddingStrategy: 0
        }
        if (this.beSelectAdType == 11) {
          data = {
            ...data, appletPath: this.idsList[parms.id].adcreativedeeplink,
            appletOriginId: this.idsList[parms.id].builtInRpkDeepLink
          }
        }

        if (this.isguanz) {
          data.wechatFollow = 1
        } else {
          data.wechatFollow = 0
        }
        if (this.advertiseQualificationId === '' || this.advertiseQualificationId === undefined) {
          data.industry1 = this.zjerji[0]
          data.industry2 = this.zjerji[1]
        } else {
          data.advertiseQualificationId = this.advertiseQualificationId[0]
        }
        if (this.beSelectCategory && Object.keys(this.beSelectCategory).length > 0) {
          data.productSDpa = {
            productId: this.beSelectCategory.id,
            productName: this.beSelectCategory.name
          }
          data.dpaGoodsConfig = {
            cpId: this.beSelectCategory.productLibraryId,
            categories: [
              {
                categoryId: this.beSelectCategory.thirdCategoryId,
                categoryLevel: 3
              }
            ]
          }
          // 将 beSelectCategory 作为 categoryId 添加
        }


        await axios.post('api/openapi/v1/ad/group/add?access_token=' + parms.token + '&timestamp=' + time1 + '&nonce=' + nonce + '&advertiser_id=' + parms.ids,
          data).then(res => {
            if (res.data.code === 70111) {
              this.$notify({
                title: '创建失败',
                message: res.data.message,
                type: 'error'
              });
            }
            console.log(res);
            this.idsList[parms.id].groundId = res.data.data
            //广告组ID

          })
      }
    },
    // 创建广告api
    async guanggao(parms) {
      // console.log('-----------------------')
      // console.log(parms.creativeList)
      // adcreativedeeplink:this.idsList[key].adcreativedeeplink
      const data = {
        creativeList: parms.creativeList,
        groupId: parms.groupId,
        name: parms.name + '_' + this.formLabelAlign.name,
        clickMonitorUrl: parms.clickMonitorUrl,
        viewMonitorUrl: parms.viewMonitorUrl
      }

      if (this.beSelectAdType == 11) {
        data.h5Type = 2

        data.pageUrl = this.idsList[parms.id].url

      } else {
        data.deepLink = parms.adcreativedeeplink
      }

      if (parms.adcreativedeeplink !== '' || parms.adcreativedeeplink !== undefined || parms.adcreativedeeplink !== null) {
        if (this.beSelectAdType == 11) {
          data.h5Type = 2
          data.pageUrl = this.idsList[parms.id].url

        } else {
          data.deepLink = parms.adcreativedeeplink
        }

      }
      // 获取当前时间
      const today = new Date();

      // 获取年、月、日（注意月份要 +1）
      const year = today.getFullYear();
      const month = String(today.getMonth() + 1).padStart(2, '0'); // 补零
      const day = String(today.getDate()).padStart(2, '0');        // 补零

      // 拼接成目标格式
      const formattedDate = `${year}-${month}-${day}`;
      // console.log(formattedDate); // 输出示例：2025-02-27

      // username: params.username
      // twoname:params.twoname
      // num:   parms.creativeList.length
      // batchtime: formattedDate



      let time1 = parseInt(new Date().getTime()) + '';
      let nonce = Math.round(Math.random() * 100000000000)
      await axios.post('api/openapi/v1/ad/advertisement/add/cu' +
        'stomize/adCreative?access_token=' + parms.token + '&timestamp=' + time1 + '&nonce=' + nonce + '&advertiser_id=' + parms.ids + '',
        data).then(async res => {

          if (res.data.code == 0) {
            await this.updateMaterialStat(this.sucainame, res.data.data.creativeIdList.length);
          }
          if (res.data.code === 70111) {
            const str = res.data.message;
            const startIndex = str.indexOf("[") + 1;
            const endIndex = str.indexOf("]");
            const code = str.substring(startIndex, endIndex);
            // const fileCode = ["12345678", "98765432"];
            // const videofileCode = ["90007642"];

            const indexFile = this.fileCode.indexOf(code);
            const indexVideo = this.videofileCode.indexOf(code);

            if (indexFile !== -1) {
              this.$notify({
                title: '创建失败',
                message: `第${indexFile + 1}张图片错误`,
                type: 'error'
              });
            } else if (indexVideo !== -1) {
              this.$notify({
                title: '创建失败',
                message: `第${indexVideo + 1}张视频错误`,
                type: 'error'
              });
            } else {
              this.$notify({
                title: '创建失败',
                message: res.data.message,
                type: 'error'
              });
            }

          }
          console.log(res.data);
          //广告组ID

        })
    },
    //获取时间方法
    //获取当前日期函数

    async updateMaterialStat(accountName, createdCount) {
      // 获取当天日期（格式 yyyy-MM-dd）
      const today = new Date().toISOString().slice(0, 10);

      // 生成幂等性 Key：账号 + 日期 + 时间戳（保证唯一性）
      // 如果是批量任务，前端应该生成一个固定的 key 并传入，这里仅做示例
      const idempotencyKey = `${accountName}-${today}-${Date.now()}`;

      try {
        await axios.post("https://control.zjwec.cn/api/creative-counts/increment", {
          accountName: accountName,       // 广告主账号
          increment: createdCount,        // 新增数量
          // date: today,                   // 统计日期
          region: '浙江',
          idempotencyKey: idempotencyKey  // 幂等 Key，避免重复累计
        });
        this.$message.success("统计数据已更新");
      } catch (e) {
        this.$message.error("更新统计数据失败");
      }
    },
    getNowFormatDate() {
      let date = new Date(),
        year = date.getFullYear(), //获取完整的年份(4位)
        month = date.getMonth() + 1, //获取当前月份(0-11,0代表1月)
        strDate = date.getDate() // 获取当前日(1-31)
      if (month < 10) month = `0${month}` // 如果月份是个位数，在前面补0
      if (strDate < 10) strDate = `0${strDate}` // 如果日是个位数，在前面补0

      return `${year}-${month}-${strDate}`
    },
    //图片上传api
    async upload() {
      let time1 = parseInt(new Date().getTime()) + '';
      // 上传图像通常要将文件参数放在fromdata 对象中
      // 创建formData实例
      // 向formData实例中追加属性 (参数1：属性名 参数2：属性值)
      // 普通素材：this.fileList
      // 撞审素材：this.zsfileList
      console.log(this.fileList)
      let num = 100 / this.fileList.length;

      for (let i = 0; i < this.fileList.length; i++) {
        let nonce = Math.round(Math.random() * 100000000000)
        let formData = new FormData()
        formData.append('file', this.fileList[i].raw)
        await axios.post('api/openapi/v1/upload/file/image?access_token=' + this.selectedsucaiku.utoken + '&timestamp=' + time1 + '&nonce=' + nonce + '&advertiser_id=' + this.selectedsucaiku.uid + '',
          formData).then(res => {
            console.log(res);
            console.log(res.data.data.fileCode);
            this.fileCode[i] = res.data.data.fileCode;
            this.percentage = num * (i + 1);
          })
      }
      if (this.percentage === 100) {
        this.$notify({
          title: 'success',
          message: '素材上传成功',
          type: 'success'
        });
      }
      console.log(this.fileCode);//这里输出的是一个空的formData对象，因为formData是加密处理的我们看不到其内容，但的的确确添加进去了。
    },
    async txupload() {
      let time1 = parseInt(new Date().getTime()) + '';
      // 上传图像通常要将文件参数放在fromdata 对象中
      // 创建formData实例
      // 向formData实例中追加属性 (参数1：属性名 参数2：属性值)
      // 撞审素材：this.zsfileList
      console.log(this.txfileList)
      let num = 100 / this.txfileList.length;

      for (let i = 0; i < this.txfileList.length; i++) {
        let nonce = Math.round(Math.random() * 100000000000)
        let formData = new FormData()
        formData.append('file', this.txfileList[i].raw)
        await axios.post('api/openapi/v1/upload/file/image?access_token=' + this.selectedsucaiku.utoken + '&timestamp=' + time1 + '&nonce=' + nonce + '&advertiser_id=' + this.selectedsucaiku.uid + '',
          formData).then(res => {
            this.txfileCode[i] = res.data.data.fileCode;
            this.percentage = num * (i + 1);
          })
      }
      if (this.percentage === 100) {
        this.$notify({
          title: 'success',
          message: '撞审素材上传成功',
          type: 'success'
        });
      }
      console.log(this.txfileCode);//这里输出的是一个空的formData对象，因为formData是加密处理的我们看不到其内容，但的的确确添加进去了。
    },
    async zsupload() {
      let time1 = parseInt(new Date().getTime()) + '';
      // 上传图像通常要将文件参数放在fromdata 对象中
      // 创建formData实例
      // 向formData实例中追加属性 (参数1：属性名 参数2：属性值)
      // 撞审素材：this.zsfileList
      console.log(this.zsfileList)
      let num = 100 / this.zsfileList.length;

      for (let i = 0; i < this.zsfileList.length; i++) {
        let nonce = Math.round(Math.random() * 100000000000)
        let formData = new FormData()
        formData.append('file', this.zsfileList[i].raw)
        await axios.post('api/openapi/v1/upload/file/image?access_token=' + this.selectedsucaiku.utoken + '&timestamp=' + time1 + '&nonce=' + nonce + '&advertiser_id=' + this.selectedsucaiku.uid + '',
          formData).then(res => {
            this.zsfileCode[i] = res.data.data.fileCode;
            this.percentage = num * (i + 1);
          })
      }
      if (this.percentage === 100) {
        this.$notify({
          title: 'success',
          message: '撞审素材上传成功',
          type: 'success'
        });
      }
      console.log(this.zsfileCode);//这里输出的是一个空的formData对象，因为formData是加密处理的我们看不到其内容，但的的确确添加进去了。
    },
    // 视频上传api
    async uploadVideo() {
      let time1 = parseInt(new Date().getTime()) + '';
      // 上传图像通常要将文件参数放在fromdata 对象中
      // 创建formData实例
      // 向formData实例中追加属性 (参数1：属性名 参数2：属性值)
      console.log(this.VideofileList)
      let num = 100 / this.VideofileList.length;

      for (let i = 0; i < this.VideofileList.length; i++) {
        let nonce = Math.round(Math.random() * 100000000000)
        let formData = new FormData()

        formData.append('file', this.VideofileList[i].raw)
        await axios.post('api/openapi/v1/upload/file/video?access_token=' + this.selectedsucaiku.utoken + '&timestamp=' + time1 + '&nonce=' + nonce + '&advertiser_id=' + this.selectedsucaiku.uid + '',
          formData).then(res => {
            console.log(res.data.data.fileCode);
            this.videofileCode[i] = res.data.data.fileCode;
            this.percentage = num * (i + 1);
            console.log('视频code' + this.videofileCode)
            // console.log(res.data.data.fileCode);
            // console.log(res.data.data.fileFullPath);
          })
      }
      if (this.percentage === 100) {
        this.$notify({
          title: 'success',
          message: '素材上传成功',
          type: 'success'
        });
      }

      console.log(this.videofileCode);//这里输出的是一个空的formData对象，因为formData是加密处理的我们看不到其内容，但的的确确添加进去了。

    },
    // 视频上传api
    async zsuploadVideo() {
      let time1 = parseInt(new Date().getTime()) + '';
      // 上传图像通常要将文件参数放在fromdata 对象中
      // 创建formData实例
      // 向formData实例中追加属性 (参数1：属性名 参数2：属性值)
      console.log(this.zsVideofileList)
      let num = 100 / this.zsVideofileList.length;

      for (let i = 0; i < this.zsVideofileList.length; i++) {
        let nonce = Math.round(Math.random() * 100000000000)
        let formData = new FormData()

        formData.append('file', this.zsVideofileList[i].raw)
        await axios.post('api/openapi/v1/upload/file/video?access_token=' + this.selectedsucaiku.utoken + '&timestamp=' + time1 + '&nonce=' + nonce + '&advertiser_id=' + this.selectedsucaiku.uid + '',
          formData).then(res => {
            console.log(res.data.data.fileCode);
            this.zsvideofileCode[i] = res.data.data.fileCode;
            this.percentage = num * (i + 1);
            console.log('视频code' + this.zsvideofileCode)
            // console.log(res.data.data.fileCode);
            // console.log(res.data.data.fileFullPath);
          })
      }
      if (this.percentage === 100) {
        this.$notify({
          title: 'success',
          message: '撞审视频素材上传成功',
          type: 'success'
        });
      }

      console.log(this.zsvideofileCode);//这里输出的是一个空的formData对象，因为formData是加密处理的我们看不到其内容，但的的确确添加进去了。

    },
    //修改日期Api
    async PostGroupTime(pams) {
      let time = parseInt(new Date().getTime()) + '';
      let nonce2 = Math.round(Math.random() * 100000000000)
      await this.$axios.post('api/openapi/v1/ad/group/batchEditTime?access_token=' + pams.token + '&timestamp=' + time + '&nonce=' + nonce2 + '&advertiser_id=' + pams.ids,
        {
          "ids": pams.groupId,
          "scheduleTime": this.time_list,
        }).then(resp => {
          if (resp.data.code === 70111) {
            this.$notify.error({
              title: '错误',
              message: '修改投放时段失败，请检查时段是否错误'
            });
          } else {
            this.$notify({
              title: '成功',
              message: '修改投放时段成功',
              type: 'success',
              position: 'bottom-left'
            });
            this.dialog = false
          }

        })


    },
    change() {
      console.log(this.towName)
    },
    onChange(a, fileList) {
      console.log(this.fileList)
      this.fileList = fileList;
    },
    txonChange(a, fileList) {
      console.log(this.txfileList)
      this.txfileList = fileList;
    },
    zsonChange(a, fileList) {
      console.log(this.zsfileList)
      this.zsfileList = fileList;
    },
    handleRemove(file, fileList) {
      console.log(file, fileList);
    },
    txhandleRemove(file, fileList) {
      // console.log(file, fileList);
    },
    zshandleRemove(file, fileList) {
      console.log(file, fileList);
    },
    handlePictureCardPreview(file) {
      console.log(file)
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
    },


    txhandlePictureCardPreview(file) {
      console.log(file)
      // this.dialogImageUrl = file.url;
      // this.dialogVisible = true;
    },
    zshandlePictureCardPreview(file) {
      console.log(file)
      // this.dialogImageUrl = file.url;
      // this.dialogVisible = true;
    },
    onChange2(a, fileList) {
      console.log(this.VideofileList)
      this.VideofileList = fileList;
    },
    zsonChange2(a, fileList) {
      console.log(this.zsVideofileList)
      this.zsVideofileList = fileList;
    },
    handleRemove2(file, fileList) {
      console.log(file, fileList);
    },
    zshandleRemove2(file, fileList) {
      console.log(file, fileList);
    },
    handlePictureCardPreview2(file) {


    },
    zshandlePictureCardPreview2(file) {


    },
    clearFiles1(file, fileList) {
      this.$refs.upload.clearFiles()
      this.$refs.upload12.clearFiles()

    },
  },
  created() {

    this.fetchHdCookieData()
    this.fetchAdvRecordTodayTotal();
    //自动加载indexs方法
    axios.get('https://test.nbweiou.cn/api/find_list_name', {
    }).then(
      res => {
        this.listname = res.data
        console.log(this.listname)
      }
    )
  },
  mounted() {
    this.fetchAdvRecordTodayTotal();
    this.advRecordTimer = setInterval(() => {
      this.fetchAdvRecordTodayTotal();
    }, 30000);
  }
}
</script>
<style>
.text {
  font-size: 14px;
}

.item {
  margin-bottom: 18px;
}

.el-form-item {
  margin-bottom: 7px;
}

.clearfix:before,
.clearfix:after {
  display: table;
  content: "";
}

.clearfix:after {
  clear: both
}


.box-card1 {
  position: absolute;
  top: 350px;
  bottom: 0;
  left: 0;
  right: 0;
  margin: 0 auto;
  width: 40%;
}

.box-card2 {
  position: absolute;
  top: 550px;
  bottom: 0;
  left: 0;
  right: 0;
  margin: 0 auto;
  width: 40%;
}

.box-cardf1s {
  position: absolute;
  top: 1050px;
  bottom: 0;
  left: 0px;
  right: 0px;
  margin: 0 auto;
  width: 40%;
}

.box-card {
  /*position: absolute;*/
  /*top: 1000px;*/
  /*bottom: 0;*/
  /*!*left: 1000px;*!*/
  /*right: 50px;*/
  /*!*margin:0 auto;*!*/
  position: fixed;
  bottom: 35px;
  right: 30px;
  width: 25%;
}

.box-cards {
  /*position: absolute;*/
  /*top: 1000px;*/
  /*bottom: 0;*/
  /*!*left: 1000px;*!*/
  /*right: 50px;*/
  /*!*margin:0 auto;*!*/
  position: fixed;
  top: 20px;
  left: 30px;
  width: 20%;
}

.jdt {
  margin: 0 auto;
}

.el-icon-plus {
  width: 20px;
  height: 20px;
}

.test {
  width: 20px;
  height: 20px;
}

.product-input {
  margin-bottom: 10px;
}
</style>



<style scoped>
.time-range-container {
  padding: 20px;
}

.time-range-item {
  margin-bottom: 10px;
  display: flex;
  align-items: center;
}

.separator {
  margin: 0 10px;
}

.el-time-select {
  width: 120px;
}

.result {
  margin-top: 20px;
  font-family: monospace;
  word-break: break-all;
}
</style>












// WEBPACK FOOTER //
// src/components/login/chpida.vue